// libraries
import React, { useContext, useState, useEffect} from "react";
import { useHistory, useParams } from "react-router-dom";

//component
import AppButton from "components/app-button";
import pathnames from "routes/pathnames";
// import { updateUserList } from "redux/slices/user-list-slice";
import IconDownload from "../../assets/images/pages/icon-download-border-none.png";
// import { FiSearch } from "react-icons/fi";
import AppReactTable from "components/app-react-table";
import { IoClose, IoTrashOutline, IoCheckmark } from "react-icons/io5";
import { BiEditAlt} from "react-icons/bi";
import AppSearchBar from "components/app-search-bar";
import Calendar from "react-calendar";
// import 'react-calendar/dist/Calendar.css';
// commons
import CONSTANSTS from "common/constansts";
import AppCustomToast, { PageContext } from "components/app-custom-toast";
import moment from "moment";

const PageMerchantView = () => {
  const indicatorValue = useContext(PageContext);
  function messageDialog(indicator) {
    AppCustomToast({
      showIndicator: indicator,
      reintIndicator: indicatorValue[1](indicator),
    });
  }
  const history = useHistory();
  const { merchantId } = useParams();
  const [accessMerchantDetails, setAccessMerchantDetails] = useState({
    download_agreement: false,
    terminate_merchant: false,
    update_merchant: false,
    view_merchant_detail: false,
    update_merchant_status: false,
    update_edited_merchant_detail: false,
    approve_merchant_update:false,
  });
  const [accessMerchantTrx, setAccessMerchantTrx] = useState({
    export_transaction_list: false,
    view_transaction_list: false,
  });
  const [accessMerchantTerminal, setAccessMerchantTerminal] = useState({
    create_merchant_terminal: false,
    delete_merchant_terminal: false,
    view_merchant_terminal_list: false,
    update_merchant_terminal: false,
    approval: false,
  });

  const [disableEditInputField, setDisableEditInputField] = useState(false);
  const [enableEditInputField, setEnableEditInputField] = useState(false);
  const [enableEditTab, setEnableEditTab] = useState(false);
  //const [enableUpdate, setEnableUpdate] = useState(false);
 // const [disableEditTab, setDisableEditTab] = useState(false);

  const inputText = {
    name: {
      placeholder: "Merchant Name",
      required: "Merchant Name required",
      invalid: "Invalid merchant name",
      regex: /^[a-zA-Z0-9 .&/-]*$/,
    },
    email: {
      placeholder: "Email",
      required: "Email required",
      invalid: "Invalid email",
      regex: CONSTANSTS.REGEX.email,
    },
    mobile: {
      placeholder: "Mobile Phone",
      required: "Mobile Phone required",
      invalid: "Invalid mobile phone",
      regex: /^.{10,}$/,
    },
    category: {
      placeholder: "Category",
      required: "Category required",
      invalid: "Invalid category",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    address1: {
      placeholder: "Address 1",
      required: "Address 1 required",
      invalid: "Invalid address 1",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    address2: {
      placeholder: "Address 2",
      required: "Address 2 required",
      invalid: "Invalid address 2",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    city: {
      placeholder: "City",
      required: "City required",
      invalid: "Invalid city",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    postcode: {
      placeholder: "Postcode",
      required: "Postcode required",
      invalid: "Invalid Postcode",
      regex: /^.{5,}$/,
    },
    state: {
      placeholder: "State",
      required: "State required",
      invalid: "Invalid state",
      regex: /^.{5,}$/,
    },
    bankCode: {
      placeholder: "Bank Name",
      required: "Bank Name required",
      invalid: "Invalid bank name",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    accName: {
      placeholder: "Account Name",
      required: "Account Name required",
      invalid: "Invalid account name",
      regex: /^[a-zA-Z0-9 .&/-]*$/,
    },
    accNumber: {
      placeholder: "Account No",
      required: "Account No required",
      invalid: "Invalid Account No",
      regex: /^.{7,}$/,
    },
    effectiveDate: {
      placeholder: "Effective Date",
      required: "Effective Date required",
      invalid: "Invalid effective date",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    businessRegNo: {
      placeholder: "Business Registration Number",
      required: "Business Reg. No required",
      invalid: "Invalid Business Reg. No",
      regex: /^[a-zA-Z0-9 ()-]*$/,
    },
    hqEmail: {
      placeholder: "Headquarters Email",
      required: "Headquarters Email required",
      invalid: "Invalid headquarters email",
      regex: CONSTANSTS.REGEX.email,
    },
  };

  const inputField = {
    refId:{
      value:"",
      error:"",
    },
    accName: {
      value: "",
      error: "",
    },
    accNumber: {
      value: "",
      error: "",
    },
    address1: {
      value: "",
      error: "",
    },
    address2: {
      value: "",
      error: "",
    },
    agreementDownloadUrl: {
      value: "",
      error: "",
    },
    bankName: {
      value: "",
      error: "",
    },
    bankCode: {
      value: "",
      error: "",
    },
    category: {
      value: "",
      error: "",
    },
    city: {
      value: "",
      error: "",
    },
    effectiveDate: {
      value: "",
      error: "",
    },
    endDate: {
      value: "",
      error: "",
    },
    name: {
      value: "",
      error: "",
    },
    postcode: {
      value: 0,
      error: "",
    },
    qrImageUrl: {
      value: "",
      error: "",
    },
    qrDownloadUrl: {
      value: null,
      error: "",
    },
    referenceNumber: {
      value: "",
      error: "",
    },
    state: {
      value: "",
      error: "",
    },
    status: {
      value: "",
      error: "",
    },
    merchantId: {
      value: "",
      error: "",
    },
    email: {
      value: "",
      error: "",
    },
    mobile: {
      value: "",
      error: "",
    },
    businessRegNo: {
      value: "",
      error: "",
    },
    subsidiary: {
      value: false,
      error: "",
    },
    hqEmail: {
      value: "",
      error: "",
    },
    userStatus: {
      value: "",
      error: "",
    },
    unlockUserCheckbox: {
      value: false,
    }
  };

  const [input, setInput] = useState(inputField);
  const [inputUp, setUpInput] = useState(inputField);
  //const [categoryList, setCategoryList] = useState(undefined);
  const [stateList, setStateList] = useState(undefined);
  const [bankList, setBankList] = useState(undefined);

  const [modifyDate, setModifyDate] = useState();

  useEffect (() => {
    
    // const appId = id.location.state;
    const appId = merchantId;
    // console.log("ID", appId)

    let dbMerchantAccess = null;
    dbMerchantAccess = JSON.parse(localStorage.getItem("accessMatrix"));

    if (dbMerchantAccess) {
      setAccessMerchantDetails(dbMerchantAccess.accessMatrix.Merchant_Detail);
      setAccessMerchantTrx(dbMerchantAccess.accessMatrix.Merchant_Transaction);
      setAccessMerchantTerminal(dbMerchantAccess.accessMatrix.Merchant_Terminal);
    }

    const loadData = async () => {
      try {
        let token = null;
        token = localStorage.getItem("@storage_token");
        // let response = fetch("http://49.0.203.50/ivc-app/bo/merchant/api/v1/get/" + appId, {
        await fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GET_MERCHANT_BYID + appId, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en", "X-DEVICE-OS": "Web",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            if (response.ok) {
              return response.json();
            } else {
              return;
            }
          })
          .then(function (data) {
            if (data !== null || data !== undefined) {
              // appToast("Sucessfully", true);
              let result = data.result;
              //console.warn("result: ", result);
              //console.log(result);

              setDisableEditInputField(!dbMerchantAccess.accessMatrix.Merchant_Detail.update_merchant || result.status == "PENDING");
             // setEnableEditInputField(!accessMerchantDetails.update_merchant || result.status == "PENDING");

              let date = result.effectiveDate;
              let modifydate = "";
              // modifydate = date.substring(6, 10) + "-" + date.substring(3, 5) + "-" + date.substring(0, 2);
              modifydate = date.substring(3, 5) + "-" + date.substring(0, 2) + "-" + date.substring(6, 10);
              setModifyDate(modifydate);
              // console.log("modifydate -> ", modifydate)
              // console.log("date -> ", new Date(modifydate))

              // let dmy = new Date(modifydate);
              // let dateFormat = dmy.toLocaleString("ms", { hour12: false }).split(" ");
              // var dt = dateFormat[0].split("/");
              // console.log(dt);
              // var day2 = parseInt(dt[0]);
              // var month2 = parseInt(dt[1]);
              // var year2 = parseInt(dt[2]);
              // var formattedDate2 = "";
              // if (day2 < 10 && month2 > 10) {
              //   formattedDate2 = "0" + day2 + "/" + month2 + "/" + year2;
              // }
              // if (month2 < 10 && day2 > 10) {
              //   formattedDate2 = "" + day2 + "/0" + month2 + "/" + year2;
              // }
              // if (day2 < 10 && month2 < 10) {
              //   formattedDate2 = "0" + day2 + "/0" + month2 + "/" + year2;
              // }
              // setDMY(formattedDate2.toString());
              setInput({
                ...input,
                accName: {
                  value: result.accName,
                },
                accNumber: {
                  value: result.accNumber,
                },
                address1: {
                  value: result.address1,
                },
                address2: {
                  value: result.address2,
                },
                agreementDownloadUrl: {
                  value: result.agreementDownloadUrl,
                },
                bankName: {
                  value: result.bankName,
                },
                bankCode: {
                  value: result.bankCode,
                },
                category: {
                  value: result.category,
                },
                city: {
                  value: result.city,
                },
                effectiveDate: {
                  value: result.effectiveDate,
                  // value: modifydate,
                },
                endDate: {
                  value: result.endDate,
                },
                name: {
                  value: result.name,
                },
                postcode: {
                  value: result.postcode,
                },
                qrImageUrl: {
                  value: result.qrImageUrl,
                },
                qrDownloadUrl: {
                  value: result.qrDownloadUrl,
                },
                referenceNumber: {
                  value: result.referenceNumber,
                },
                state: {
                  value: result.state,
                },
                status: {
                  value: result.status,
                },
                merchantId: {
                  value: result.merchantId,
                },
                email: {
                  value: result.email,
                },
                mobile: {
                  value: result.mobileNumber,
                },
                businessRegNo: {
                  value: result.businessRegNo,
                },
                subsidiary: {
                  value: result.hqEmail !== null && result.hqEmail !== ""
                },
                hqEmail: {
                  value: result.hqEmail || ""
                },
                userStatus: {
                  value: result.userStatus || ""
                }
              });
              if (result.status === "ACTIVE") {
                setIsChecked(true);
              } else {
                setIsChecked(false);
              }
              // setReactDate(new Date(modifydate));
              return result
            }
          })
          .then(function (data){
            //console.log(data);
            loadUpdateData(data);          
          });
      } catch (error) {
        console.log("error", error);
      }
    };
    loadData();

    const loadUpdateData = async (rel) => {
      try {
       // const appId = merchantId;
        let token = null;
        token = localStorage.getItem("@storage_token");
        // let response = fetch("http://49.0.203.50/ivc-app/bo/merchant/api/v1/get/" + appId, 
        await fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GET_MERCHANT_UPDATE_LIST , {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en", "X-DEVICE-OS": "Web",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            if (response.ok) {
              return response.json();
            } else {
              return;
            }
          })
          
          .then(async function (data) {
            if (data !== null || data !== undefined) {
              // appToast("Sucessfully", true);
              let result = data.result;
              let changedResult ="";
              let lastKey = "";
              let v = {};
             // console.log(result);
              Object.entries(result).forEach(([key, value]) =>{
                v[key] = value[1];

              }); 
              for (var e in v) {
               // console.log(v[e]);
                if(v[e].referenceNumber == rel.referenceNumber)
                {
                  //console.log(v[e].referenceNumber)
                  changedResult = v[e];
                  lastKey = e;
                  if(v[e].endDate != null)
                  {
                    changedResult.endDate =  moment(changedResult.endDate).format("DD/MM/YYYY");
                  }
                  else
                  {
                    changedResult.endDate = v[e].endDate;

                  }
                  break;
                }
              }
              setDisableEditInputField(!dbMerchantAccess.accessMatrix.Merchant_Detail.update_merchant || result.status == "PENDING" || changedResult.referenceNumber == rel.referenceNumber ||
              v[e].referenceNumber == rel.referenceNumber || accessMerchantDetails.update_merchant);
              setEnableEditInputField(dbMerchantAccess.accessMatrix.Merchant_Detail.update_merchant || changedResult.referenceNumber != rel.referenceNumber || !dbMerchantAccess.accessMatrix.Merchant_Detail.approve_merchant_update);
              setEnableEditTab(!dbMerchantAccess.accessMatrix.Merchant_Detail.update_merchant || changedResult.referenceNumber == rel.referenceNumber ||
                v[e] == rel);
              //setDisableEditTab(v[0] != rel || v[1] != rel);
              //if(accessMerchantDetails.update_merchant || changedResult.status == "PENDING")
              if(changedResult.referenceNumber == rel.referenceNumber)
              {       
              setUpInput({
                ...inputUp,
                refId:{
                  value: lastKey,
                },          
                accName: {
                  value: changedResult.accName,
                },
                accNumber: {
                  value: changedResult.accNumber,
                },
                address1: {
                  value: changedResult.address1,
                },
                address2: {
                  value: changedResult.address2,
                },
                agreementDownloadUrl: {
                  value: changedResult.agreementDownloadUrl,
                },
                bankName: {
                  value: changedResult.bankName,
                },
                bankCode: {
                  value: changedResult.bankCode,
                },
                category: {
                  value: changedResult.category,
                },
                city: {
                  value: changedResult.city,
                },
                effectiveDate: {
                  value: changedResult.effectiveDate,
                  // value: modifydate,
                },
                endDate: {
                  value: changedResult.endDate,
                },
                name: {
                  value: changedResult.name,
                },
                postcode: {
                  value: changedResult.postcode,
                },
                qrImageUrl: {
                  value: changedResult.qrImageUrl,
                },
                qrDownloadUrl: {
                  value: changedResult.qrDownloadUrl,
                },
                referenceNumber: {
                  value: changedResult.referenceNumber,
                },
                state: {
                  value: changedResult.state,
                },
                status: {
                  value: changedResult.status,
                },
                merchantId: {
                  value: changedResult.merchantId,
                },
                email: {
                  value: changedResult.email,
                },
                mobile: {
                  value: changedResult.mobileNumber,
                },
                businessRegNo: {
                  value: changedResult.businessRegNo,
                },
                subsidiary: {
                  value: changedResult.hqEmail !== null
                },
                hqEmail: {
                  value: changedResult.hqEmail || ""
                },
                userStatus: {
                  value: changedResult.userStatus || ""
                }
              });
            }
              if (changedResult.status === "ACTIVE") {
                setIsStatusChecked(true);
              } else {
                setIsStatusChecked(false);
              }
              // setReactDate(new Date(modifydate));
              return changedResult;
            }
          })
          .then(function (changedResult){
            //console.log(data);
            checkSame(changedResult, rel);        
          });
          
      } catch (error) {
        console.log("error", error);
      }
    }

    // const fetchCategory = async () => {
    //   // fetch("http://49.0.203.50/ivc-app/common/api/v1/findDropdownOption/" + "MERCHANT_CATEGORY", {
    //   fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.COMMON_FIND_DROPDOWN_OPTION + "MERCHANT_CATEGORY", {
    //     method: "GET",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Accept: "*/*",
    //       "Accept-language": "en", "X-DEVICE-OS": "Web",
    //     },
    //   })
    //     .then((response) => response.json())
    //     .then((json) => {
    //       let res = json.result;
    //       setCategoryList(res);
    //       // console.log("category:", res)
    //     });
    // };
    const fetchState = async () => {
      // fetch("http://49.0.203.50/ivc-app/common/api/v1/findDropdownOption/" + "STATE", {
      fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.COMMON_FIND_DROPDOWN_OPTION + "STATE", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
        },
      })
        .then((response) => response.json())
        .then((json) => {
          let res = json.result;
          setStateList(res);
          // console.log("state:", res, stateList)
        });
    };
    const fetchBank = async () => {
      // fetch("http://49.0.203.50/ivc-app/common/api/v1/findDropdownOption/" + "BANK", {
      fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.COMMON_FIND_DROPDOWN_OPTION + "BANK", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
        },
      })
        .then((response) => response.json())
        .then((json) => {
          let res = json.result;
          setBankList(res);
          // console.log("bank:", res, bankList)
        });
    };
    // const fetchHeadquarters = async () => {
    //   let token = null;
    //   token = localStorage.getItem("@storage_token");
    //   fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GET_MAIN_MERCHANT_LIST, {
    //     method: "GET",
    //     headers: {
    //       // "Content-Type": "application/json",
    //       Accept: "*/*",
    //       "Accept-language": "en", "X-DEVICE-OS": "Web",
    //       Authorization: "Bearer " + token
    //     },
    //   })
    //     .then((response) => response.json())
    //     .then((json) => {
    //       let res = json.result;
    //       setHqList(res);
    //     });
    // };
   // fetchCategory();
    fetchState();
    fetchBank();
    // fetchHeadquarters();
  }, []);

  const [nameValidate, setNameValidate] = useState("app-input-text");
  const [emailValidate, setEmailValidate] = useState("app-input-text");
  const [mobilePhoneValidate, setMobilePhoneValidate] = useState("app-input-text");
  const [categoryValidate, setCategoryValidate] = useState("app-input-text");
  const [address1Validate, setAddress1Validate] = useState("app-input-text");
  const [address2Validate] = useState("app-input-text");
  const [cityValidate, setCityValidate] = useState("app-input-text");
  const [postcodeValidate, setPostcodeValidate] = useState("app-input-text");
  const [stateValidate, setStateValidate] = useState("app-input-select app-input-select__input");
  const [bankCodeValidate, setBankCodeValidate] = useState("app-input-select app-input-select__input");
  const [accNameValidate, setAccNameValidate] = useState("app-input-text");
  const [accNumberValidate, setAccNumberValidate] = useState("app-input-text");
  const [disableBtn, setDisableBtn] = useState(false);
  const [businessRegNoValidate, setBusinessRegNoValidate] = useState("app-input-text");
  const [hqEmailValidate, setHqEmailValidate] = useState("app-input-text");

  const [nameLbl, setNameLbl] = useState("app-input-text");
  const [emailLbl, setEmailLbl] = useState("app-input-text");
  const [mobilePhoneLbl, setMobilePhoneLbl] = useState("app-input-text");
  const [categoryLbl, setCategoryLbl] = useState("app-input-text");
  const [address1Lbl, setAddress1Lbl] = useState("app-input-text");
  const [address2Lbl, setAddress2Lbl] = useState("app-input-text");
  const [cityLbl, setCityLbl] = useState("app-input-text");
  const [postcodeLbl, setPostcodeLbl] = useState("app-input-text");
  const [stateLbl, setStateLbl] = useState("app-input-select app-input-select__input");
  const [bankCodeLbl, setBankCodeLbl] = useState("app-input-select app-input-select__input");
  const [accNameLbl, setAccNameLbl] = useState("app-input-text");
  const [accNumberLbl, setAccNumberLbl] = useState("app-input-text");
  const [businessRegNoLbl, setBusinessRegNoLbl] = useState("app-input-text");
  const [endDateLbl, setEndDateLbl] = useState("app-input-text");
  const [statusLbl, setStatusLbl] = useState("app-input-text");
  const [hqEmailLbl, setHqEmailLbl] = useState("app-input-text");
  const [subsidiaryLbl, setSubsidiaryLbl] = useState("app-input-text");

  const updateMerchantDetail = async () => {
    const nameValidate = CONSTANSTS.REGEX.checkEmpty.test(input.name.value);
    if (nameValidate === false && input.name.value === "") {
      setNameValidate("app-input-text-error");
    } else {
      setNameValidate("app-input-text");
    }
    const emailValidate = CONSTANSTS.REGEX.email.test(input.email.value);
    if (emailValidate === false && input.email.value === "") {
      setEmailValidate("app-input-text-error");
    } else {
      setEmailValidate("app-input-text");
    }
    const mobilePhoneValidate = inputText.mobile.regex.test(input.mobile.value);
    if (mobilePhoneValidate === false && input.mobile.value === "") {
      setMobilePhoneValidate("app-input-text-error");
    } else {
      setMobilePhoneValidate("app-input-text");
    }
    const categoryValidate = CONSTANSTS.REGEX.checkEmpty.test(input.category.value);
    if (categoryValidate === false) {
      setCategoryValidate("app-input-select-error app-input-select-error__input");
    } else {
      setCategoryValidate("app-input-select app-input-select__input");
    }
    const address1Validate = CONSTANSTS.REGEX.checkEmpty.test(input.address1.value);
    if (address1Validate === false) {
      setAddress1Validate("select-input-error");
    } else {
      setAddress1Validate("select-input");
    }
    const postcodeValidate = inputText.postcode.regex.test(input.postcode.value);
    if (postcodeValidate === false && input.postcode.value === "") {
      setPostcodeValidate("app-input-text-error");
    } else {
      setPostcodeValidate("app-input-text");
    }
    const cityValidate = CONSTANSTS.REGEX.checkEmpty.test(input.city.value);
    if (cityValidate === false && input.city.value === "") {
      setCityValidate("app-input-text-error");
    } else {
      setCityValidate("app-input-text");
    }
    const stateValidate = CONSTANSTS.REGEX.checkEmpty.test(input.state.value);
    if (stateValidate === false) {
      setStateValidate("app-input-select-error app-input-select-error__input");
    } else {
      setStateValidate("app-input-select app-input-select__input");
    }
    const bankCodeValidate = CONSTANSTS.REGEX.checkEmpty.test(input.bankCode.value);
    if (bankCodeValidate === false) {
      setBankCodeValidate("app-input-select-error app-input-select-error__input");
    } else {
      setBankCodeValidate("app-input-select app-input-select__input");
    }
    const accNameValidate = CONSTANSTS.REGEX.checkEmpty.test(input.accName.value);
    if (accNameValidate === false && input.accName.value === "") {
      setAccNameValidate("app-input-text-error");
    } else {
      setAccNameValidate("app-input-text");
    }
    const accNumberValidate = inputText.accNumber.regex.test(input.accNumber.value);
    if (accNumberValidate === false && input.accNumber.value === "") {
      setAccNumberValidate("app-input-text-error");
    } else {
      setAccNumberValidate("app-input-text");
    }
    const businessRegNoValidate = CONSTANSTS.REGEX.checkEmpty.test(input.businessRegNo.value);
    if (businessRegNoValidate === false && input.businessRegNo.value === "") {
      setBusinessRegNoValidate("app-input-text-error");
    } else {
      setBusinessRegNoValidate("app-input-text");
    }
    const hqEmailValidate = CONSTANSTS.REGEX.email.test(input.email.value);
    if (hqEmailValidate === false && input.hqEmail.value === "" && input.subsidiary.value) {
      setHqEmailValidate("app-input-text-error");
    } else {
      setHqEmailValidate("app-input-text");
    }

    if (
      nameValidate === true && input.name.value !== "" && inputText.name.regex.test(input.name.value) === true &&
      emailValidate === true && input.email.value !== "" &&
      mobilePhoneValidate === true && input.mobile.value !== "" && inputText.mobile.regex.test(input.mobile.value) === true &&
      categoryValidate === true && input.category.value !== "" &&
      address1Validate === true && input.address1.value !== "" &&
      cityValidate === true && input.city.value !== "" &&
      postcodeValidate === true && input.postcode.value !== "" && inputText.postcode.regex.test(input.postcode.value) === true &&
      stateValidate === true && input.state.value !== "" &&
      bankCodeValidate === true && input.bankCode.value !== "" &&
      accNameValidate === true && input.accName.value !== "" && inputText.accName.regex.test(input.accName.value) === true &&
      accNumberValidate === true && input.accNumber.value !== "" && inputText.accNumber.regex.test(input.accNumber.value) === true &&
      businessRegNoValidate === true && input.businessRegNo.value !== "" && inputText.businessRegNo.regex.test(input.businessRegNo.value) === true &&
      input.subsidiary.value ? (hqEmailValidate === true && input.hqEmail.value !== "") : true
    ) {
      setDisableBtn(true);
      setTimeout(() => {
        setDisableBtn(false);
      }, 6000);
      // const merchantId = id.location.state
      let token = null;
      token = localStorage.getItem("@storage_token");
      // fetch("http://49.0.203.50/ivc-app/bo/merchant/api/v1/update/" + merchantId, {
      fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.UPDATE_MERCHANT + merchantId, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          address1: input.address1.value.trim(),
          address2: input.address2.value.trim(),
          bankAccName: input.accName.value.trim(),
          bankAccNumber: input.accNumber.value,
          bankCode: input.bankCode.value,
          category: input.category.value,
          city: input.city.value.trim(),
          name: input.name.value.trim(),
          postcode: input.postcode.value,
          state: input.state.value,
          status: isChecked === true ? "ACTIVE" : "DISABLED",
          effectiveDate: input.effectiveDate.value,
          endDate: input.endDate.value,
          email: input.email.value,
          mobileNumber: input.mobile.value,
          businessRegNo: input.businessRegNo.value.toUpperCase(),
          mainMerchantName: "",
          hqEmail: input.subsidiary.value ? input.hqEmail.value : null,
          userStatus: input.userStatus.value !== "LOCKED" ? input.userStatus.value : (input.unlockUserCheckbox.value ? "ENABLED" : "LOCKED"),
        }),
      })
        .then(function (response) {
          return response.json();
          
        })
        .then(function (data) {
          const items = data;
          if (items.responseCode === 200) {
            // history.push(pathnames.pageMerchantList);
            messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.success, title: CONSTANSTS.DIALOG_TITLE.general_success, message: items.message });
          } else {
            messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: items.message, defaultOnClick: false });
          }
        });
    } else {
      return;
    }
  };

  const back = async () => {
    history.push(pathnames.pageMerchantList);
  };

  const [tabCol1, setTabCol1] = useState("tab-selected");
  const [tabCol2, setTabCol2] = useState("tab2");
  const [tabCol3, setTabCol3] = useState("tab3");
  const [tabCol4, setTabCol4] = useState("tab4");
  const [firstTab, setFirstTab] = useState("display");
  const [secondTab, setSecondTab] = useState("hide");
  const [thirdTab, setThirdTab] = useState("hide");
  const [forthTab, setForthTab] = useState("hide");
  // const [cdTab, setCDTab] = useState("contents");
  const [contentStyling, setContentStyling] = useState("merchant-detail");
  const tabClicked = (e) => {
    var tabNo = e;
    if (tabNo === "1") {
      setTabCol1("tab-selected");
      setTabCol2("tab2");
      setTabCol3("tab3");
      setTabCol4("tab4");
      setFirstTab("display");
      setSecondTab("hide");
      setThirdTab("hide");
      setForthTab("hide");
      // setCDTab("contents");

    }
    if (tabNo === "2") {
      setTabCol1("tab1");
      setTabCol2("tab-selected");
      setTabCol3("tab3");
      setTabCol4("tab4");
      setFirstTab("hide");
      setSecondTab("display");
      setThirdTab("hide");
      setForthTab("hide");
      // setCDTab("none");

      setContentStyling("merchant-detail-2");
    }
    if (tabNo === "3") {
      setTabCol1("tab1");
      setTabCol2("tab2");
      setTabCol3("tab-selected");
      setTabCol4("tab4");
      setFirstTab("hide");
      setSecondTab("hide");
      setThirdTab("display");
      setForthTab("hide");
      // setCDTab("none");
    }
    if (tabNo === "4") {
      setTabCol1("tab1");
      setTabCol2("tab2");
      setTabCol3("tab3");
      setTabCol4("tab-selected");
      setFirstTab("hide");
      setSecondTab("hide");
      setThirdTab("hide");
      setForthTab("display");
      // setCDTab("none");
    }
  };

  const onHandleSearch = () => {
    setTableSearchFilter({
      pageNo: tableSearchFilter.pageNo,
      pageSize: tableSearchFilter.pageSize,
      sortBy: tableSearchFilter.sortBy,
      sortDir: tableSearchFilter.sortDir,
      dateRangeType: selected == "- Select Range -" ? null : selected,
      dateFrom: tableSearchFilter.dateFrom != "string" ? tableSearchFilter.dateFrom : "string",
      dateTo: tableSearchFilter.dateTo != "string" ? tableSearchFilter.dateTo : "string",
      keyword: searchValue,
    });
  };

  const openFile = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    let fileName = "";
    fileName = input.referenceNumber.value;
    fetch(input.agreementDownloadUrl.value, {
      method: "GET",
      headers: {
        "Content-Disposition": "attachment; filename=" + fileName + "_Merchant Agreement.pdf",
        "Content-Type": "application/pdf",
        Vary: "Origin,Access-Control-Request-Method,Access-Control-Request-Headers",
        "X-Content-Type-Options": "nosniff",
        "X-XSS-Protection": "1; mode=block",
        "Cache-Control": "no-cache, no-store, max-age=0, must-revalidate",
        "Keep-Alive": "timeout=5, max=100",
        Connection: "Keep-Alive",
        Authorization: "Bearer " + token,
        "X-DEVICE-OS": "Web",
      },
    }).then((response) => {
      let filename = response.headers.get("Content-Disposition");
      if (filename != null) {
        filename = filename.split(";")[1].split("filename=")[1];
      }
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        // a.download = fileName + "_Merchant Agreement.pdf";
        a.download = filename;
        a.click();
      });
    });
  };

  const openPDF = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    let fileName = "";
    fileName = input.referenceNumber.value;
    // console.log(input.qrDownloadUrl.value)
    fetch(input.qrDownloadUrl.value, {
      method: "GET",
      headers: {
        "Content-Disposition": "attachment; filename=" + fileName + "_Merchant QR.pdf",
        "Content-Type": "application/pdf",
        Vary: "Origin,Access-Control-Request-Method,Access-Control-Request-Headers",
        "X-Content-Type-Options": "nosniff",
        "X-XSS-Protection": "1; mode=block",
        "Cache-Control": "no-cache, no-store, max-age=0, must-revalidate",
        "Keep-Alive": "timeout=5, max=100",
        Connection: "Keep-Alive",
        Authorization: "Bearer " + token,
        "X-DEVICE-OS": "Web",
      },
    }).then((response) => {
      let filename = response.headers.get("Content-Disposition");
      if (filename != null) {
        filename = filename.split(";")[1].split("filename=")[1];
      }
      response.blob().then((blob) => {
        // console.log(blob)
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        // a.download = fileName + "_Merchant QR.pdf";
        a.download = filename;
        a.click();
      });
    });
  };

  const terminate = (endDate) => {
    console.log(dmy);
    const appId = merchantId;
    let token = null;
    token = localStorage.getItem("@storage_token");
    let terminateDate = endDate.replace("/", "%2F").replace("/", "%2F").replace(",", "");
    console.log("terminateDate", terminateDate, endDate)
   
    // let payload = {
    //   id: Number(appId),
    //   endDate: endDate,
    // }

    // fetch("http://49.0.203.50/ivc-app/bo/merchant/api/v1/terminate/" + appId, {
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.UPDATE_MERCHANT + appId , {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        address1: input.address1.value.trim(),
        address2: input.address2.value.trim(),
        bankAccName: input.accName.value.trim(),
        bankAccNumber: input.accNumber.value,
        bankCode: input.bankCode.value,
        category: input.category.value,
        city: input.city.value.trim(),
        name: input.name.value.trim(),
        postcode: input.postcode.value,
        state: input.state.value,
        status: isChecked === true ? "ACTIVE" : "DISABLED",
        effectiveDate: input.effectiveDate.value,
        email: input.email.value,
        endDate: endDate,
        mobileNumber: input.mobile.value,
        businessRegNo: input.businessRegNo.value.toUpperCase(),
        mainMerchantName: "",
        hqEmail: input.subsidiary.value ? input.hqEmail.value : null,
        userStatus: input.userStatus.value !== "LOCKED" ? input.userStatus.value : (input.unlockUserCheckbox.value ? "ENABLED" : "LOCKED"),
      }),
      // body: JSON.stringify(payload),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        // console.log(items)
        if (items.responseCode === 200) {
          // history.push(pathnames.pageMerchantList);
          messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.success, title: CONSTANSTS.DIALOG_TITLE.general_success, message: items.message });
          setTerminatePopUp(false);
          
        } else {
          setTerminatePopUp(false);
        }
      });
  };

  const [isChecked, setIsChecked] = useState(false);
  const [isStatusChecked, setIsStatusChecked] = useState(false);
  const handleOnChange = () => {
    setStatusPopUp(true);
    //setEnableUpdate(true);
    // setIsChecked(!isChecked);
  };

  const onHandle = (event) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    
    if (name === "mobile" || name === "postcode" || name === "accNumber") {
      setInput({
        ...input,
        [name]: {
          ...input[name],
          error: errorMessage(name, value),
          value: value.replace(/\D/, ""),
        },
      });
    } else {
      setInput({
        ...input,
        [name]: {
          ...input[name],
          error: errorMessage(name, value),
          value: value,
        },
      });
    }
    checkEmpty(name, value);
   // setEnableUpdate(true);
  };

  const onUpdate = (event) => {
    const name = event.currentTarget.name;
    const valueUp = event.currentTarget.value;
    const value = event.currentTarget.value;

    if (name === "mobile" || name === "postcode" || name === "accNumber") {
      setUpInput({
        ...inputUp,
        [name]: {
          ...inputUp[name],     
          error: errorMessage(name, valueUp, value),
          value: valueUp.replace(/\D/, ""),
        },
      });
    } else {
      setUpInput({
        ...inputUp,
        [name]: {
          ...inputUp[name],
          error: errorMessage(name, valueUp, value),
          value: valueUp,
          
        },
      });
    }
    checkUpdateEmpty(name, valueUp, value);
    //checkEmpty(name, value);
  };

  const checkSame = (changedResult, rel) =>
  {
   // let l = data
      let inputUp= changedResult;
      if (inputUp.name!= rel.name) {
        setNameLbl("card-red");
      } 
      if (inputUp.email !== rel.email) {
        setEmailLbl("card-red");
      }
      if (inputUp.mobileNumber !== rel.mobileNumber) {
        setMobilePhoneLbl("card-red");
      }
      if (inputUp.category !== rel.category) {
        setCategoryLbl("card-red");
      }
      if (inputUp.address1 !== rel.address1) {
        setAddress1Lbl("card-red");
      }
      if (inputUp.address2 !== rel.address2) {
        setAddress2Lbl("card-red");
      }
      if (inputUp.city !== rel.city) {
        setCityLbl("card-red");
      }
      if (inputUp.postcode!== rel.postcode) {
        setPostcodeLbl("card-red");
      }
      if (inputUp.state !== rel.state) {
        setStateLbl("card-red");
      }
      if (inputUp.bankCode!== rel.bankCode) {
        setBankCodeLbl("card-red");
      }
      if (inputUp.accName !==  rel.accName) {
        setAccNameLbl("card-red");
      } 
      if (inputUp.accNumber !== rel.accNumber) {
        setAccNumberLbl("card-red");
      } 
      if (inputUp.businessRegNo != rel.businessRegNo) {
        setBusinessRegNoLbl("card-red");
      }
      if (inputUp.endDate!= rel.endDate) {
        setEndDateLbl("card-red");
      }
      if (inputUp.status!= rel.status) {
        setStatusLbl("card-red");
      }
      if (inputUp.hqEmail != rel.hqEmail) {
        setHqEmailLbl("card-red");
      }
      if (inputUp.hqEmail != rel.hqEmail && (rel.hqEmail == null || rel.hqEmail == "")) {
        setSubsidiaryLbl("card-red")
      }
    };
    

  const checkUpdateEmpty = (name, valueUp) => {
    // console.log(name, value)
    if (name === "name") {
      if (valueUp !== input.name.value) {
        setNameLbl("card-red");
      } 
      else {
        setNameLbl("app-input-text");  
      }
    }
    if (name === "email") {
      if (valueUp !== input.email.value) {
        setEmailLbl("app-input-text-error card-red");
        
      } else {
        setEmailLbl("app-input-text");
        
      }
    }
    if (name === "mobile") {
      if (valueUp !== input.mobile.value) {
        setMobilePhoneLbl("app-input-text-error card-red");
      } else {
        setMobilePhoneLbl("app-input-text");
      }
    }
    if (name === "category") {
      if (valueUp !== input.category.value) {
        setCategoryLbl("app-input-select-error app-input-select-error__input card-red");
      } else {
        setCategoryLbl("app-input-select app-input-select__input");
      }
    }
    if (name === "address1") {
      if (valueUp !== input.address1.value) {
        setAddress1Lbl("app-input-text-error card-red");
      } else {
        setAddress1Lbl("app-input-text");
      }
    }
    if (name === "address2") {
      if (valueUp !== input.address2.value) {
        setAddress2Lbl("app-input-text-error card-red");
      } else {
        setAddress2Lbl("app-input-text");
      }
    }
    if (name === "city") {
      if (valueUp !== input.city.value) {
        setCityLbl("app-input-text-error card-red");
      } else {
        setCityLbl("app-input-text");
      }
    }
    if (name === "postcode") {
      if (valueUp !== input.postcode.value) {
        setPostcodeLbl("app-input-text-error card-red");
      } else {
        setPostcodeLbl("app-input-text");
      }
    }
    if (name === "state") {
      if (valueUp !== input.state.value) {
        setStateLbl("app-input-select-error app-input-select-error__input card-red");
      } else {
        setStateLbl("app-input-select app-input-select__input");
      }
    }
    if (name === "bankCode") {
      if (valueUp !== input.bankCode.value) {
        setBankCodeLbl("app-input-select-error app-input-select-error__input card-red");
      } else {
        setBankCodeLbl("app-input-select app-input-select__input");
      }
    }
    if (name === "accName") {
      if (valueUp !==  input.accName.value) {
        setAccNameLbl("app-input-text-error card-red");
      } else {
        setAccNameLbl("app-input-text");
      }
    }
    if (name === "accNumber") {
      if (valueUp !== input.accNumber.value) {
        setAccNumberLbl("app-input-text-error card-red");
      } else {
        setAccNumberLbl("app-input-text");
      }
    }
    if (name === "businessRegNo") {
      if (valueUp !== input.businessRegNo.value) {
        setBusinessRegNoLbl("app-input-text-error card-red");
      } else {
        setBusinessRegNoLbl("app-input-text");
      }
    }
    // if (name === "terminalId") {
    //   if (value === "") {
    //     setTerminalIdValidate("app-input-text-error");
    //   } else {
    //     setTerminalIdValidate("app-input-text");
    //   }
    // }
    // if (name === "deviceName") {
    //   if (valueUp !== input.deviceName.value) {
    //     setDeviceNameLbl("app-input-text-error card-red");
    //   } else {
    //     setDeviceNameLbl("app-input-text");
    //   }
    // }
    if (name === "hqEmail") {
      if (valueUp === input.hqEmail.value && input.subsidiary.value) {
        setHqEmailLbl("app-input-text-error card-red");
      } else {
        setHqEmailLbl("app-input-text");
      }
    }
  };

  const checkEmpty = (name, value) => {
    // console.log(name, value)
    if (name === "name") {
      if (value === "") {
        setNameValidate("app-input-text-error");
      } else {
        setNameValidate("app-input-text");
      }
    }
    if (name === "email") {
      if (value === "") {
        setEmailValidate("app-input-text-error");
      } else {
        setEmailValidate("app-input-text");
      }
    }
    if (name === "mobile") {
      if (value === "") {
        setMobilePhoneValidate("app-input-text-error");
      } else {
        setMobilePhoneValidate("app-input-text");
      }
    }
    if (name === "category") {
      if (value === "") {
        setCategoryValidate("app-input-select-error app-input-select-error__input");
      } else {
        setCategoryValidate("app-input-select app-input-select__input");
      }
    }
    if (name === "address1") {
      if (value === "") {
        setAddress1Validate("select-input-error");
      } else {
        setAddress1Validate("select-input");
      }
    }
    if (name === "city") {
      if (value === "") {
        setCityValidate("app-input-text-error");
      } else {
        setCityValidate("app-input-text");
      }
    }
    if (name === "postcode") {
      if (value === "") {
        setPostcodeValidate("app-input-text-error");
      } else {
        setPostcodeValidate("app-input-text");
      }
    }
    if (name === "state") {
      if (value === "") {
        setStateValidate("app-input-select-error app-input-select-error__input");
      } else {
        setStateValidate("app-input-select app-input-select__input");
      }
    }
    if (name === "bankCode") {
      if (value === "") {
        setBankCodeValidate("app-input-select-error app-input-select-error__input");
      } else {
        setBankCodeValidate("app-input-select app-input-select__input");
      }
    }
    if (name === "accName") {
      if (value === "") {
        setAccNameValidate("app-input-text-error");
      } else {
        setAccNameValidate("app-input-text");
      }
    }
    if (name === "accNumber") {
      if (value === "") {
        setAccNumberValidate("app-input-text-error");
      } else {
        setAccNumberValidate("app-input-text");
      }
    }
    if (name === "businessRegNo") {
      if (value === "") {
        setBusinessRegNoValidate("app-input-text-error");
      } else {
        setBusinessRegNoValidate("app-input-text");
      }
    }
    // if (name === "terminalId") {
    //   if (value === "") {
    //     setTerminalIdValidate("app-input-text-error");
    //   } else {
    //     setTerminalIdValidate("app-input-text");
    //   }
    // }
    if (name === "terminalId") {
      if (value === "") {
        setTerminalIdValidate("app-input-text-error");
      } else {
        setTerminalIdValidate("app-input-text");
      }
    }
    if (name === "deviceName") {
      if (value === "") {
        setDeviceNameValidate("app-input-text-error");
      } else {
        setDeviceNameValidate("app-input-text");
      }
    }
    if (name === "editedDeviceName") {
      if (value === "") {
        setEditedDeviceNameValidate("app-input-text-error");
      } else {
        setEditedDeviceNameValidate("app-input-text");
      }
    }
    if (name === "hqEmail") {
      if (value === "" && input.subsidiary.value) {
        setHqEmailValidate("app-input-text-error");
      } else {
        setHqEmailValidate("app-input-text");
      }
    }
  };

  const errorMessage = (name, value) => {
    if (!value) {
      return inputText[name].required;
    } else if (!inputText[name].regex.test(value)) {
      return inputText[name].invalid;
    } else {
      return "";
    }
  };

  // secondTab //

  const [tableSearchFilter, setTableSearchFilter] = useState({
    // insert the key value requested by BE here
    pageNo: 1,
    pageSize: 50,
    sortBy: "id",
    sortDir: "ASCENDING",
    dateRangeType: null,
    dateFrom: "string",
    dateTo: "string",
    keyword: "",
  });

  // trigger when user click on header when sorting
  const headerFilterClick = (header) => {
    let column = header.column;
    if (tableSearchFilter.sortBy === column.searchFilterValue) {
      // if click on the same column previously clicked will enter here
      if (tableSearchFilter.sortDir === "ASCENDING") {
        // if previously the column is sort by ascending order, sortDir will change to sort by descending order
        setTableSearchFilter({
          ...tableSearchFilter,
          sortBy: column.searchFilterValue,
          sortDir: "DESCENDING",
          pageNo: 1,
        });
      } else {
        // if previously the column is sort by descending order, sortDir will change to sort by ascending order
        setTableSearchFilter({
          ...tableSearchFilter,
          sortBy: column.searchFilterValue,
          sortDir: "ASCENDING",
          pageNo: 1,
        });
      }
    } else {
      // if click on a new column, it will sort by ascending order with the column value (column.searchFilterValue)
      setTableSearchFilter({
        ...tableSearchFilter,
        sortBy: column.searchFilterValue,
        sortDir: "ASCENDING",
        pageNo: 1,
      });
    }
  };

  const headerArrowRotate = (active) => {
    // current column header arrow icon will rotate depending on ascending order or descending order (tableSearchFilter.sortDir)
    const classNames = ["react-table__icon-wrapper"];
    if (active && tableSearchFilter.sortDir === "DESCENDING") classNames.push("react-table__icon-wrapper-down");
    if (active) classNames.push("react-table__icon-wrapper--show");
    return classNames.join(" ");
  };

  // tableCoumn is to create table column
  const tableColumn = [
    {
      id: "referenceNumber",
      // header is the table header for id column
      Header: (header) => {
        return (
          <div onClick={() => headerFilterClick(header)} className="react-table__header">
            <span className="react-table__header-title">Transaction Ref</span>
            <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      // accessor will list out the table data based on the data key. In this case, the mockData key of id
      accessor: "referenceNumber",
      // searchFilterValue is the column value that will send to BE to inform BE to sort according to which column. it is use to update tableSearchFilter.searchValue
      searchFilterValue: "referenceNumber",
      // minWidth, width, maxWidth is to adjust the width of this current column
      minWidth: 200,
      width: 200,
    },
    {
      id: "customerName",
      Header: (header) => {
        return (
          <div onClick={() => headerFilterClick(header)} className="react-table__header">
            <span className="react-table__header-title">Customer Name</span>
            <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "customerName",
      accessor: "customerName",
      minWidth: 200,
    },
    {
      id: "amount",
      Header: (header) => {
        return (
          <div onClick={() => headerFilterClick(header)} className="react-table__header">
            <span className="react-table__header-title">Amount</span>
            <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "amount",
      accessor: "amount",
      minWidth: 120,
      width: 120,
    },
    {
      id: "dateCreated",
      Header: (header) => {
        return (
          <div onClick={() => headerFilterClick(header)} className="react-table__header">
            <span className="react-table__header-title">Transaction Date</span>
            <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "dateCreated",
      accessor: "dateCreated",
      minWidth: 160,
      width: 160,
    },
    {
      id: "status",
      Header: (header) => {
        return (
          <div onClick={() => headerFilterClick(header)} className="react-table__header">
            <span className="react-table__header-title">Status</span>
            <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "status",
      accessor: "status",
      minWidth: 160,
      width: 160,
    },
    {
      id: "remarks",
      Header: (header) => {
        return (
          <div onClick={() => headerFilterClick(header)} className="react-table__header">
            <span className="react-table__header-title">Remarks</span>
            <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "remarks",
      accessor: "remarks",
      minWidth: 160,
      width: 160,
    },
  ];

  // third tab
  const [terminalTable, setTerminalTable] = useState({
    // insert the key value requested by BE here
    pageNo: 1,
    pageSize: 50,
    sortDir: "ASCENDING",
    sortBy: "id",
  });

  const [terminalId, setTerminalId] = useState("");
  const [cancelPopUp2, setCancelPopUp2] = useState(false);
  const [PopupEdit, setPopupEdit] = useState(false);
  const [terminalList, setTerminalList] = useState(undefined);
  

  function PopupCancel2(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-data">
          {props.children}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button className="pop-up-button" style={{ marginRight: "10px" }} onClick={() => cancelTransaction(terminalId)}>
              OK
            </button>
            <button className="pop-up-button" style={{ marginLeft: "10px" }} onClick={() => [setCancelPopUp2(false)]}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  const cancelTransaction = async (value) => {
    let id = "";
    id = value.id;
    // console.log(id)
    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.DELETE_MERCHANT_TERMINAL + "?id=" + id, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + token,
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        if (items.responseCode === 200) {
          setCancelPopUp2(false);
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message: items.message,
            defaultOnClick: false,
          });
          getMerchantTerminalList();
        } else {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: items.message,
            defaultOnClick: false,
          });
        }
      });
  };
  const tInput = {
    deviceName: {
      value: "",
      error: ""
    }
  }

  const [updateTerminalInput, setUpdateTerminalInput] = useState(tInput);
  const [disableUpdateButton, setDisableUpdateButton] = useState(true);

  const onHandleUpdateTerminalDeviceName = (event) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    updateTerminalInput.deviceName.value=value
    setDisableUpdateButton(false),
   checkEmpty(name, value);
  };

  function PopupEditTerminal(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-data">
          {props.children}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button className="pop-up-button" disabled={disableUpdateButton} style={{ marginRight: "10px"}} onClick={() => updateTerminalInfo(terminalId)} >
              Update
            </button>
            <button className="pop-up-button" style={{ marginLeft: "10px" }} onClick={() => [setPopupEdit(false)]}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }
  
  const terminalApproval = async (value, isApprove) => {
    console.log("terminalApproval - param -", value, isApprove);
    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.APPROVE_MERCHANT_TERMINAL + "?deviceId=" + value.deviceId + "&isApprove=" + isApprove, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + token,
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        if (items.responseCode === 200) {
          // setCancelPopUp2(false);
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message: items.message,
            defaultOnClick: false,
          });
          getMerchantTerminalList();
        } else {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: items.message,
            defaultOnClick: false,
          });
        }
      });
  };

  const terminalTableColumn = [
    {
      id: "terminalId",
      // header is the table header for id column
      Header: (header) => {
        return (
          <div className="react-table__header">
            <span className="react-table__header-title">Reference</span>
            <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      // accessor will list out the table data based on the data key. In this case, the mockData key of id
      accessor: "terminalId",
      // searchFilterValue is the column value that will send to BE to inform BE to sort according to which column. it is use to update tableSearchFilter.searchValue
      searchFilterValue: "terminalId",
      // minWidth, width, maxWidth is to adjust the width of this current column
      minWidth: 200,
      width: 200,
    },
    {
      id: "deviceName",
      Header: (header) => {
        return (
          <div className="react-table__header">
            <span className="react-table__header-title">Device Name</span>
            <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "deviceName",
      accessor: "deviceName",
      minWidth: 200,
    },
    {
      id: "tempDeviceName", 
      Header: (header) => {
        var arr = [];
        for (var i = 0; i < terminalList.data.length; i++) {
          arr.push(terminalList.data[i].status);
        }
        return Object.values(arr).includes('PENDING_UPDATE') == true && accessMerchantTerminal.approval ? (
          <div className="react-table__header" style={{flex: "200px 0 auto", width:"200px", marginRight:"20px"}}>
            <span className="react-table__header-title">Edited Device Name</span>
            <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
              <span className="react-table__icon"></span>
            </div>
          </div>
        ) : null;
      },
      searchFilterValue: "tempDeviceName",
      accessor: "tempDeviceName",
    },
    {
      id: "deviceId",
      Header: (header) => {
        return (
          <div className="react-table__header">
            <span className="react-table__header-title">Terminal ID</span>
            <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "deviceId",
      accessor: "deviceId",
      minWidth: 200,
    },
    {
      id: "dateUpdated",
      Header: (header) => {
        return (
          <div className="react-table__header">
            <span className="react-table__header-title">Updated Date</span>
            <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "dateUpdated",
      accessor: "dateUpdated",
      minWidth: 200,
    },
    {
      id: "status",
      Header: (header) => {
        return (
          <div className="react-table__header">
            <span className="react-table__header-title">Status</span>
            <div className={headerArrowRotate(tableSearchFilter.sortBy === header.column.searchFilterValue)}>
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "status",
      accessor: "status",
      minWidth: 200,
    },
    {
      id: "button",
      Header: "",
      Cell: (row) => {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            {row.row.original.status == "PENDING_CREATE" || row.row.original.status == "PENDING_DELETE" || row.row.original.status == "PENDING_UPDATE" ? (
              accessMerchantTerminal.approval && (
                <>
                <button onClick={() => [terminalApproval(row.row.original, true)]} className="react-table__search-button" style={{marginRight: "3px"}}>
                  <IoCheckmark size={24} />
                </button>
                <button onClick={() => [terminalApproval(row.row.original, false)]} className="react-table__search-button">
                  <IoClose size={24} />
                </button>
                </>
              )
            ) 
            : 
            (accessMerchantTerminal.update_merchant_terminal && (
              <>
              <button onClick={() => [setPopupEdit(true), setTerminalId(row.row.original)]} className="react-table__search-button" style={{marginRight: "3px"}}>
                <BiEditAlt size={24} />
              </button>
              </>
            ))}
            {row.row.original.status == "ACTIVE" ?(accessMerchantTerminal.delete_merchant_terminal &&(
               <>
               <button onClick={() => [setCancelPopUp2(true), setTerminalId(row.row.original)]} className="react-table__search-button">
                <IoTrashOutline size={24} />
              </button>
               </>
            )
            ):null}
            <PopupCancel2 trigger={cancelPopUp2}>
              <div className="pop-up-message">
                {/* <input
                  type="text"
                  placeholder="Please provide remarks"
                  style={{ fontSize: "20px", width: "80%" }}
                  name="remark2"
                  onChange={handleOnChange2}
                /> */}
                <p>Are you sure you want to cancel this terminal?</p>
              </div>
            </PopupCancel2>
            <PopupEditTerminal trigger={PopupEdit} >
            {accessMerchantTerminal.update_merchant_terminal ? 
              <>
              <p className="pop-up-message">Edit Terminal</p>
              <div className="pop-up-message" style={{marginBottom:"20px"}}>
              <div className="pop-up-message-content" >
                  <div className="app-input" style={{marginLeft: "10px"}}>
                    <span style={{fontSize: "20px", marginRight:"15px"}}>Device Name: </span>
                  </div>
                  <div className="app-input">
                  {/* {Object.keys(terminalList.data).map((keys, index) => ( */}
                    <input type="text" autoFocus placeholder={terminalId.deviceName}  className={editedDeviceNameValidate} name="deviceName" onChange={onHandleUpdateTerminalDeviceName} style={{ width: "400px", height: "50px" }} />
                    {/* ))} */}
                  </div>
                </div>
              </div>
              </>
              : <div></div>
              }
            </PopupEditTerminal>
          </div>
        );
      },
      minWidth: 90,
      width: 90,
    },
  ];

 

  const updateTerminalInfo = async (value) => {
    let terminalId = value.terminalId;
    let id = value.id;
    let token = null;
    //console.log(id,terminalId,updateTerminalInput.deviceId.value, updateTerminalInput.deviceName.value);
   token = localStorage.getItem("@storage_token");
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.UPDATE_MERCHANT_TERMINAL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(
        {
          "id":id,
          "terminalId": terminalId,
          "deviceName": updateTerminalInput.deviceName.value, 
        }
      )
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        if (items.responseCode === 200) {
          setPopupEdit(false);
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message: items.message,
            defaultOnClick: false,
          });
          getMerchantTerminalList();
        } else {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: items.message,
            defaultOnClick: false,
          });
        }
      });
  }


  const [appList, setAppList] = useState(undefined);
  

  const [searchValue, setSearchValue] = useState("");

  const [paginationLocker, setPaginationLocker] = useState(true);
  const [paginationTerminalLocker, setPaginationTerminalLocker] = useState(true);
  const [exportBtn, setExportBtn] = useState("orange");

  useEffect(() => {
    const fetchData = async () => {


      let token = null;
      token = localStorage.getItem("@storage_token");
      try {
        // let response = fetch("http://49.0.203.50/ivc-app/bo/merchant/api/v1/transactionList", {
        let response = fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GET_MERCHANT_TRANSACTION_LIST + "?merchantId=" + merchantId, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en", "X-DEVICE-OS": "Web",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            criteria: {
              dateFrom: tableSearchFilter.dateFrom,
              dateRangeType: tableSearchFilter.dateRangeType,
              dateTo: tableSearchFilter.dateTo,
              keyword: tableSearchFilter.keyword,
            },
            pageNumber: tableSearchFilter.pageNo,
            pageSize: tableSearchFilter.pageSize,
            sortDirection: tableSearchFilter.sortDir,
            sortKey: tableSearchFilter.sortBy,
          }),
        })
          .then((response) => response.json())
          .then((json) => {
            let result = json;
            // console.log(result)
            if (result.responseCode === 200) {
              setAppList(result.result);
              setPaginationLocker(false);
              if (result.result.totalCount === 0) {
                setExportBtn("dimmed");
              } else {
                setExportBtn("orange");
              }
            } else {
              messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: response.message, defaultOnClick: false });
            }
          });
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [tableSearchFilter]);


  const getMerchantTerminalList = () => {
    const fetchData = async () => {
      let token = null;
      token = localStorage.getItem("@storage_token");
      try {
        let response = fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.LIST_MERCHANT_TERMINAL + "?merchantId=" + merchantId, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en", "X-DEVICE-OS": "Web",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            criteria: {
              keyword: ""
            },
            pageNumber: terminalTable.pageNo,
            pageSize: terminalTable.pageSize,
            sortDirection: terminalTable.sortDir,
            sortKey: terminalTable.sortBy,
          }),
        })
          .then((response) => response.json())
          .then((json) => {
            let result = json;
            console.log("terminal table", result)
            if (result.responseCode === 200) {
              setTerminalList(result.result);
              setPaginationTerminalLocker(false);
              if (result.result.totalCount === 0) {
                setExportBtn("dimmed");
              } else {
                setExportBtn("orange");
              }
            } else {
              messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: response.message, defaultOnClick: false });
            }
          });
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }

  useEffect(() => {
    setTerminalInput(terminalInputField)
    setUpdateTerminalInput({
      ...updateTerminalInput,
      deviceName: {
        value: terminalId.deviceName,
      },
    })
    getMerchantTerminalList();
  }, []);

  const onKeyUp = (event) => {
    if (event.key === "Enter") {
      console.log("enter press here! ", event);
    }
  };

  const onBlur = (e) => {
    setSearchValue(e.target.value);
  };

  const dateFields = {
    dateRange: null,
    dateFrom: "",
    dateTo: "",
  };

  const inputDateProp = [
    { type: "text", placeholder: "Start Date", value: "" },
    { type: "text", placeholder: "End Date", value: "" },
  ];

  const [dateInput, setDateInput] = useState(dateFields);
  const [selected, setSelected] = useState(null);
  const [dateType, setDateType] = useState(inputDateProp);
  const [mindate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");

  const onHandleOnChange = (event) => {
    var value = event.currentTarget.value;
    if (value === "- Select Range -") {
      setSelected(null);
      value = null;
    } else {
      setSelected(value);
    }

    setDateType(inputDateProp);
    setMinDate("");
    setMaxDate("");

    setTableSearchFilter({
      pageNo: 1,
      pageSize: tableSearchFilter.pageSize,
      sortBy: tableSearchFilter.sortBy,
      sortDir: tableSearchFilter.sortDir,
      dateRangeType: value,
      dateFrom: "string",
      dateTo: "string",
      keyword: tableSearchFilter.keyword,
    });
  };

  const onHandleCheckbox = (dataName) => {
    setInput({
      ...input,
      [`${dataName}`]: {
        value: !input[`${dataName}`].value,
        error: ""
      }
    })
  }

  const onFocusDateStart = () => {
    setDateType([
      {
        type: "date",
        placeholder: dateType[0].placeholder,
        value: dateType[0].value,
      },
      {
        type: "date",
        placeholder: dateType[1].placeholder,
        value: dateType[1].value,
      },
    ]);
  };

  const onFocusDateEnd = () => {
    setDateType([
      {
        type: "date",
        placeholder: dateType[0].placeholder,
        value: dateType[0].value,
      },
      {
        type: "date",
        placeholder: dateType[1].placeholder,
        value: dateType[1].value,
      },
    ]);
  };

  const onChangeDateStart = (event) => {
    dateType[0].value = event.currentTarget.value.toString();
    const value = event.currentTarget.value.toString();
    console.log("start date", value);
    setMinDate(value);
    let date = value;
    let dateSplit = date.split("-");
    console.log(dateSplit[2] + "/" + dateSplit[1] + "/" + dateSplit[0]);
    setDateInput({ dateFrom: dateSplit[2] + "/" + dateSplit[1] + "/" + dateSplit[0], dateTo: dateInput.dateTo });
    setSelected("- Select Range -");

    if (maxDate !== "") {
      setTableSearchFilter({
        pageNo: tableSearchFilter.pageNo,
        pageSize: tableSearchFilter.pageSize,
        sortBy: tableSearchFilter.sortBy,
        sortDir: tableSearchFilter.sortDir,
        dateRangeType: null,
        // dateFrom: dateInput.dateFrom,
        dateFrom: dateSplit[2] + "/" + dateSplit[1] + "/" + dateSplit[0],
        dateTo: dateInput.dateTo,
        keyword: tableSearchFilter.keyword,
      });
    }
  };

  const onChangeDateEnd = (event) => {
    dateType[1].value = event.currentTarget.value.toString();
    const value = event.currentTarget.value.toString();
    console.log("end date ", value);
    setMaxDate(value);
    let date = value;
    let dateSplit = date.split("-");
    console.log(dateSplit[2] + "/" + dateSplit[1] + "/" + dateSplit[0]);
    setDateInput({ dateFrom: dateInput.dateFrom, dateTo: dateSplit[2] + "/" + dateSplit[1] + "/" + dateSplit[0] });
    setSelected("- Select Range -");

    if (mindate !== "") {
      setTableSearchFilter({
        pageNo: tableSearchFilter.pageNo,
        pageSize: tableSearchFilter.pageSize,
        sortBy: tableSearchFilter.sortBy,
        sortDir: tableSearchFilter.sortDir,
        dateRangeType: null,
        dateFrom: dateInput.dateFrom,
        dateTo: dateSplit[2] + "/" + dateSplit[1] + "/" + dateSplit[0],
        keyword: tableSearchFilter.keyword,
      });
    }
  };

  const nextPage = async () => {
    if (appList.currentPageNumber < appList.totalPageNumber && !paginationLocker) {
      setTableSearchFilter({
        pageNo: tableSearchFilter.pageNo + 1,
        pageSize: tableSearchFilter.pageSize,
        sortBy: tableSearchFilter.sortBy,
        sortDir: tableSearchFilter.sortDir,
        dateRangeType: tableSearchFilter.dateRangeType,
        dateFrom: tableSearchFilter.dateFrom,
        dateTo: tableSearchFilter.dateTo,
        keyword: tableSearchFilter.keyword,
      });
      setPaginationLocker(true);
    } else if (appList.currentPageNumber === appList.totalPageNumber) {
      setPaginationLocker(false);
    }
  };

  const previousPage = async () => {
    if (appList.currentPageNumber > 1 && !paginationLocker) {
      setTableSearchFilter({
        pageNo: tableSearchFilter.pageNo - 1,
        pageSize: tableSearchFilter.pageSize,
        sortBy: tableSearchFilter.sortBy,
        sortDir: tableSearchFilter.sortDir,
        dateRangeType: tableSearchFilter.dateRangeType,
        dateFrom: tableSearchFilter.dateFrom,
        dateTo: tableSearchFilter.dateTo,
        keyword: tableSearchFilter.keyword,
      });
      setPaginationLocker(true);
    } else if (appList.currentPageNumber === 1) {
      setPaginationLocker(false);
    }
  };

  /*
  // Parse our locale string to [date, time]
  var date = new Date().toLocaleString("ms", { hour12: false }).split(" ");

  // Now we can access our time at date[1], and monthdayyear @ date[0]
  // var time = date[1];
  var mdy = date[0];

  // We then parse  the mdy into parts
  mdy = mdy.split("/");
  var day = parseInt(mdy[0]);
  var month = parseInt(mdy[1]);
  var year = parseInt(mdy[2]);

  // Putting it all together
  // var formattedDate = day + '-' + month + '-' + year + ' ' + time;
  var formattedDate = "";
  if (day < 10 && month > 10) {
    formattedDate = "0" + day + "" + month + "" + year;
  }
  if (month < 10 && day > 10) {
    formattedDate = "" + day + "0" + month + "" + year;
  }
  if (day < 10 && month < 10) {
    formattedDate = "0" + day + "0" + month + "" + year;
  }
  const [currentDate] = useState(formattedDate.toString());
  */

  const nextTerminalPage = async () => {
    if (terminalList.currentPageNumber < terminalList.totalPageNumber && !paginationTerminalLocker) {
      setTerminalTable({
        pageNo: terminalTable.pageNo + 1,
        pageSize: terminalTable.pageSize,
        sortBy: terminalTable.sortBy,
        sortDir: terminalTable.sortDir,
      });
      setPaginationTerminalLocker(true);
    } else if (terminalList.currentPageNumber === terminalList.totalPageNumber) {
      setPaginationTerminalLocker(false);
    }
  };

  const previousTerminalPage = async () => {
    if (terminalList.currentPageNumber > 1 && !paginationTerminalLocker) {
      setTerminalTable({
        pageNo: terminalTable.pageNo - 1,
        pageSize: terminalTable.pageSize,
        sortBy: terminalTable.sortBy,
        sortDir: terminalTable.sortDir,
      });
      setPaginationTerminalLocker(true);
    } else if (terminalList.currentPageNumber === 1) {
      setPaginationTerminalLocker(false);
    }
  };

  const exportList = (btn) => {
    if (btn === "orange") {
      let token = null;
      token = localStorage.getItem("@storage_token");
      try {
        // let response = fetch("http://49.0.203.50/ivc-app/bo/merchant/api/v1/exportTransactionList", {
        fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GET_MERCHANT_EXPORT_TRANSACTION_LIST + "?merchantId=" + merchantId, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en", "X-DEVICE-OS": "Web",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            criteria: {
              dateFrom: tableSearchFilter.dateFrom,
              dateRangeType: tableSearchFilter.dateRangeType,
              dateTo: tableSearchFilter.dateTo,
              keyword: tableSearchFilter.keyword,
            },
            pageNumber: tableSearchFilter.pageNo,
            pageSize: tableSearchFilter.pageSize,
            sortDirection: tableSearchFilter.sortDir,
            sortKey: tableSearchFilter.sortBy,
          }),
        }).then((response) => {
          let filename = response.headers.get("Content-Disposition");
          if (filename != null) {
            filename = filename.split(";")[1].split("filename=")[1];
          }
          response.blob().then((blob) => {
            console.log(blob);
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            // a.download = "Merchant_Transaction_" + currentDate + ".xlsx";
            a.download = filename;
            a.click();
          });
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      return;
    }
  };

  // const [showSelectTime, setShowSelectTime] = useState(false);
  // const selectTimeToggle = () => {
  //     setShowSelectTime(!showSelectTime);
  // };

  const [terminatePopUp, setTerminatePopUp] = useState(false);
  const [statusPopUp, setStatusPopUp] = useState(false);
  const [cancelPopUp, setCancelPopUp] = useState(false);
  const [calendarPopUp, setCalendarPopUp] = useState(false);
  // const [transactionId, setTransactionId] = useState();
  function Popup(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-data">
          {props.children}
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
            <button className="pop-up-button" style={{ marginRight: "10px" }} onClick={() => [setTerminatePopUp(false), setCalendarPopUp(true)]}>
              {/* onClick={terminate} */}
              Yes
            </button>
            <button className="pop-up-button" style={{ marginLeft: "10px" }} onClick={() => [setTerminatePopUp(false)]}>
              No
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  function PopupStatus(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-data">
          {props.children}
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
            <button className="pop-up-button" style={{ marginRight: "10px" }} onClick={() => [setIsChecked(!isChecked), setStatusPopUp(false)]}>
              Yes
            </button>
            <button className="pop-up-button" style={{ marginLeft: "10px" }} onClick={() => setStatusPopUp(false)}>
              No
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  function PopupCancel(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-data">
          {props.children}
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>
            <button className="pop-up-button" style={{ marginRight: "10px" }} onClick={() => createNewTerminal()}>
              Add
            </button>
            <button className="pop-up-button" style={{ marginLeft: "10px" }} onClick={() => [setCancelPopUp(false)]}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  function PopUpCalendar(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-data">
          <div style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
            <IoClose
              style={{ cursor: "pointer" }}
              size={30}
              onClick={() => {
                setCalendarPopUp(false);
              }}
            />
          </div>
          {props.children}
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  // const [reactDate, setReactDate] = useState(new Date());
  const [dmy] = useState("");
  const changeDate = (reactDate) => {
    // setReactDate(reactDate);
    //
    let dateFormat = reactDate.toLocaleString("ms", { hour12: false }).split(" ");
    var dt = dateFormat[0].split("/");
    // console.log(dt);
    var day3 = parseInt(dt[0]);
    var month3 = parseInt(dt[1]);
    var year3 = parseInt(dt[2]);
    var formattedDate3 = "";
    if (day3 < 10 && month3 < 10) {
      formattedDate3 = "0" + day3 + "/0" + month3 + "/" + year3;
    } else if (day3 < 10 && month3 >= 10) {
      formattedDate3 = "0" + day3 + "/" + month3 + "/" + year3;
    } else if (month3 < 10 && day3 >= 10) {
      formattedDate3 = "" + day3 + "/0" + month3 + "/" + year3;
    } else {
      formattedDate3 = "" + day3 + "/" + month3 + "/" + year3;
    }
    console.log("reactDate", reactDate);
    console.log("dateFormat", dateFormat[0], dt);
    console.log("get terminate date", formattedDate3.toString());
    // setDMY(formattedDate3.toString());
    setCalendarPopUp(false);
    terminate(formattedDate3.toString());
  };

  const createNewTerminal = () => {
    let id = merchantId;
    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.CREATE_MERCHANT_TERMINAL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(
        {
          "deviceName": terminalInput.deviceName.value,
          "merchantId": Number(id),
          "deviceId": terminalInput.terminalId.value
        }
      )
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        if (items.responseCode === 200) {
          setCancelPopUp(false);
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message: items.message,
            defaultOnClick: false,
          });
          getMerchantTerminalList();
        } else {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: items.message,
            defaultOnClick: false,
          });
        }
      });
  }

  const terminalInputField = {
    terminalId: {
      value: "",
      error: ""
    },
    deviceName: {
      value: "",
      error: ""
    }
  }

  const [terminalInput, setTerminalInput] = useState();
  const [terminalIdValidate, setTerminalIdValidate] = useState("app-input-text");
  const [deviceNameValidate, setDeviceNameValidate] = useState("app-input-text");
  const [editedDeviceNameValidate, setEditedDeviceNameValidate] = useState("app-input-text");

  const onHandleCreateTerminalTerminalId = (event) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    terminalInput.terminalId.error=errorMessageForTerminal(name, value)
    terminalInput.terminalId.value=value
    // setTerminalInput({
    //   ...terminalInput,
    //   [name]: {
    //     ...terminalInput[name],
    //     error: errorMessageForTerminal(name, value),
    //     value: value,
    //   },
    // });

   checkEmpty(name, value);
  };

  const onHandleCreateTerminalDeviceName = (event) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    terminalInput.deviceName.error=errorMessageForTerminal(name, value)
    terminalInput.deviceName.value=value
    // setTerminalInput({
    //   ...terminalInput,
    //   [name]: {
    //     ...terminalInput[name],
    //     error: errorMessageForTerminal(name, value),
    //     value: value,
    //   },
    // });

   checkEmpty(name, value);
  };

  const terminalInputText = {
    terminalId: {
      placeholder: "Terminal Id",
      required: "Terminal Id required",
      invalid: "Invalid Terminal Id",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    deviceName: {
      placeholder: "Device Name",
      required: "Device Name required",
      invalid: "Invalid Device Name",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
  }

  const errorMessageForTerminal = (name, value) => {
    if (!value) {
      return terminalInputText[name].required;
    } else if (!terminalInputText[name].regex.test(value)) {
      return terminalInputText[name].invalid;
    } else {
      return "";
    }
  };

  const approvalAction = (action) => {
    let tempStatus = '';
    if (action) {
      tempStatus = "APPROVED"
    } else {
      tempStatus = "REJECTED"
    }
    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.UPDATE_MERCHANT_STATUS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(
        {
          "referenceNumber": input.referenceNumber.value,
          "status": tempStatus
        }
      )
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        if (items.responseCode === 200) {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message: items.message,
            defaultOnClick: false,
          });
          history.push(pathnames.pageMerchantList)
        } else {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: items.message,
            defaultOnClick: false,
          });
        }
      });
  }


  const approvalUpdateAction = (action) => {
    let tempStatus = '';
    let refNum = inputUp.refId.value;
    if (action) {
      tempStatus = "APPROVED"
    } else {
      tempStatus = "REJECTED"
    }
    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.UPDATE_EDITED_MERCHNAT_DETAIL 
      + "?referenceNumber=" + refNum +"&status=" + tempStatus , {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + token,
      },
     
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        if (items.responseCode === 200) {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message: items.message,
            defaultOnClick: false,
          });
          history.push(pathnames.pageMerchantList)
        } else {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: items.message,
            defaultOnClick: false,
          });
        }
      });
  }

  return (
    <div className="merchant-view">
      <div className="top-context">
        <div className="tabs">
          <div>
            <div className={"tablinks " + tabCol1} onClick={() => tabClicked("1")}>
              <span>Merchant Details</span>
            </div>
             {enableEditTab&& (
                <>
                 <div className={"tablinks " + tabCol4} onClick={() => tabClicked("4")}>
                 <span>Edit Merchant Details</span>
                  </div>
                </>
               )
             }
            <div className={"tablinks " + tabCol2} onClick={() => tabClicked("2")}>
              <span>Transaction</span>
            </div>
            <div className={"tablinks " + tabCol3} onClick={() => tabClicked("3")}>
              <span>Terminal</span>
            </div>
            
          </div>
          {/* {cdTab === "contents" ? (
            <>
              <div className="tablinks"></div>
              <div className="tablinks" style={{ width: "50px" }}></div>
              <div className="search-button" style={{ marginRight: "20px" }}>
                <AppButton colorType="orange" label="Update" onClick={updateMerchantDetail} disabled={disableBtn}></AppButton>
              </div>
              <div className="search-button">
                <AppButton colorType="orange" label="Cancel" onClick={back}></AppButton>
              </div>
            </>
          ) : (
            <>
              <div className="tablinks" style={{ width: "400px" }}></div>
              <div className="search-bar">
                <AppSearchBar placeholder="Search for..." onKeyEnter={onKeyUp} onBlur={onBlur} onClick={onHandleSearch}></AppSearchBar>
              </div>
              <div className="search-button">
                <AppButton colorType={exportBtn} label="Export" onClick={() => exportList(exportBtn)}></AppButton>
              </div>
            </>
          )} */}
          {tabCol1 === "tab-selected" && accessMerchantDetails.update_merchant && (
            <div style={{display: 'flex'}}>
              {accessMerchantDetails.update_merchant_status &&
               input.status.value == 'PENDING' && (
                <>
                  <div className="search-button" style={{ marginRight: "20px" }}>
                    <AppButton colorType="orange" label="Approve" onClick={() => approvalAction(true)} disabled={disableBtn}></AppButton>
                  </div>
                  <div className="search-button" style={{ marginRight: "20px" }}>
                    <AppButton colorType="orange" label="Reject" onClick={() => approvalAction(false)} disabled={disableBtn}></AppButton>
                  </div>
                </>
               )
              }
              {!disableEditInputField && !enableEditTab &&
                <>
                  <div className="search-button" style={{ marginRight: "20px" }}>
                    <AppButton colorType="orange" label="Update" onClick={updateMerchantDetail} disabled={disableBtn}></AppButton>
                  </div>
                  <div className="search-button">
                    <AppButton colorType="orange" label="Cancel" onClick={back}></AppButton>
                  </div>
                </>
              }
            </div>
          )}
          {tabCol2 === "tab-selected" && (
            <div style={{display: 'flex'}}>
              {/* <div className="tablinks" style={{ width: "400px" }}></div> */}
              <div className="search-bar">
                <AppSearchBar placeholder="Search for..." onKeyEnter={onKeyUp} onBlur={onBlur} onClick={onHandleSearch}></AppSearchBar>
              </div>
              {accessMerchantTrx.export_transaction_list &&
              <div className="search-button">
                <AppButton colorType={exportBtn} label="Export" onClick={() => exportList(exportBtn)}></AppButton>
              </div>
              }
            </div>
          )}
          {tabCol3 === "tab-selected" && accessMerchantTerminal.create_merchant_terminal && (
            <>
              <div className="tablinks"></div>
              <div className="tablinks" style={{ width: "360px" }}></div>
              <div className="search-button" style={{ marginRight: "20px" }}>
                <AppButton colorType="orange" label="Add New Terminal" onClick={() => setCancelPopUp(true)} disabled={disableBtn}></AppButton>
              </div>
              <PopupCancel trigger={cancelPopUp}>
                <p className="pop-up-message">Add New Terminal</p>
                <div className="pop-up-message-content" >
                  <div className="app-input">
                    <span style={{fontSize: "20px", marginRight:"15px"}}>Terminal ID: </span>
                    {/* <input type="text" placeholder={terminalInputText.terminalId.placeholder} className={terminalIdValidate} name="terminalId" value={terminalInput.terminalId.value} onChange={onHandleCreateTerminal} style={{ width: "400px", height: "50px" }} /> */}
                  </div>
                  <div className="app-input">
                    {/* <span>Device Name</span> */}
                    <input type="text" autoFocus placeholder={terminalInputText.terminalId.placeholder} className={terminalIdValidate} name="terminalId"  onChange={onHandleCreateTerminalTerminalId} style={{ width: "400px", height: "50px" }} />
                  </div>
                  <div className="app-input" style={{marginLeft: "10px"}}>
                    <span style={{fontSize: "20px", marginRight:"15px"}}>Device Name: </span>
                  </div>
                  <div className="app-input">
                    <input type="text" placeholder={terminalInputText.deviceName.placeholder} className={deviceNameValidate} name="deviceName"  onChange={onHandleCreateTerminalDeviceName} style={{ width: "400px", height: "50px" }} />
                  </div>
                </div>
              </PopupCancel>
            </>
          )}
          {tabCol4 === "tab-selected" && accessMerchantDetails.update_merchant &&  (
            <div style={{display: 'flex'}}>
              {enableEditTab && accessMerchantDetails.approve_merchant_update &&
                (
                <>
                  <div className="search-button" style={{ marginRight: "10px" }}>
                    <AppButton colorType="orange" label="Approve" onClick={() => approvalUpdateAction(true)} disabled={disableBtn}></AppButton>
                  </div>
                  <div className="search-button" style={{ marginRight: "10px" }}>
                    <AppButton colorType="orange" label="Reject" onClick={() => approvalUpdateAction(false)} disabled={disableBtn}></AppButton>
                  </div>
                </>
               )
              }
            </div>
          )}
        </div>
      </div>
      <div className={contentStyling}>
        <div className={firstTab}>
          <div className="cards" style={{ paddingTop: "30px" }}>
            <div className="card">
              {/* <div className="grid-container">
                                <div className="item1">Merchant ID</div>
                                <div className="res-data"><span>{input.referenceNumber.value} asd ads asdf a fadfdfa</span></div>
                            </div>
                            <div className="grid-container">
                                <div className="item1">Merchant Name</div>
                                <div className="res-data"><span>{input.name.value}</span></div>
                            </div> */}
              <div className="grid">
                <div>Merchant ID</div>
                {/* <div className="res-data">
                                    <span>{input.referenceNumber.value}</span>
                                </div> */}
                <div className="app-input">
                  <input type="text" className="app-input-text" name="referenceNumber" value={input.referenceNumber.value} readOnly />
                  <p></p>
                </div>
              </div>
              <div className="grid">
                <div>Merchant Name</div>
                {/* <div className="res-data">
                                    <span>{input.name.value}</span>
                                </div> */}
                <div className="app-input">
                  <input type="text" className={nameValidate} name="name" value={input.name.value} onChange={onHandle} maxLength={50} readOnly={disableEditInputField || enableEditTab} />
                  <p className="app-auth-input__error">{input.name.error}</p>
                </div>
              </div>
              <div className="grid">
                <div>Merchant Email</div>
                <div className="app-input">
                  <input type="text" className={emailValidate} name="email" value={input.email.value} onChange={onHandle} readOnly={disableEditInputField || enableEditTab} />
                  <p className="app-auth-input__error">{input.email.error}</p>
                </div>
              </div>
              <div className="grid">
                <div>Mobile Phone</div>
                <div className="app-input">
                  <input type="text" className={mobilePhoneValidate} name="mobile" value={input.mobile.value} onChange={onHandle} maxLength={11} readOnly={disableEditInputField || enableEditTab} />
                  <p className="app-auth-input__error">{input.mobile.error}</p>
                </div>
              </div>
              <div className="grid">
               <div>Category Name</div>
                <div className="app-input">
                   <input type="text" className={categoryValidate} name="category" value={input.category.value} onChange={onHandle} readOnly={disableEditInputField || enableEditTab} />
                    <p className="app-auth-input__error"></p>
                   </div>
              </div>
              <div className="grid">
                <div>Address 1</div>
                <div className="app-input">
                  {/* <input type="text" className="app-input-text" name="address1" value={input.address1.value} onChange={onHandle} /> */}
                  <textarea name="address1" id="address1" className={address1Validate} value={input.address1.value} onChange={onHandle} maxLength={100} readOnly={disableEditInputField || enableEditTab}></textarea>
                </div>
                <div className="app-input">
                  <p className="app-auth-input__error"></p>
                </div>
                <div className="app-input">
                  <p className="app-auth-input__error">{input.address1.error}</p>
                </div>
              </div>
              <div className="grid">
                <div>Address 2</div>
                <div className="app-input">
                  {/* <input type="text" className="app-input-text" name="address2" value={input.address2.value} onChange={onHandle} /> */}
                  <textarea name="address2" id="address2" className="select-input"  value={input.address2.value} onChange={onHandle} maxLength={100} readOnly={disableEditInputField || enableEditTab}></textarea>
                </div>
                <div className="app-input">
                  <p></p>
                </div>
              </div>
              <div className="grid">
                <div>City / Town</div>
                <div className="app-input">
                  <input type="text" className={cityValidate} name="city" value={input.city.value} onChange={onHandle} maxLength={50} readOnly={disableEditInputField || enableEditTab} />
                  <p className="app-auth-input__error">{input.city.error}</p>
                </div>
              </div>
              <div className="grid">
                <div>Postcode</div>
                <div className="app-input">
                  <input type="text" className={postcodeValidate} name="postcode" value={input.postcode.value} onChange={onHandle} maxLength={5} readOnly={disableEditInputField || enableEditTab} />
                  <p className="app-auth-input__error">{input.postcode.error}</p>
                </div>
              </div>
              <div className="grid">
                <div>State</div>
                <div className="app-input">
                  {/* <input type="text" className="app-input-text" name="state" value={input.state.value} onChange={onHandle} /> */}
                  {stateList !== undefined ? (
                    <select name="state" id="state" className={stateValidate} style={{ textAlign: "left" }} value={input.state.value} onChange={onHandle} disabled={disableEditInputField || enableEditTab}>
                      <option value="" selected>
                        -- State --
                      </option>
                      {stateList
                        .sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))
                        .map((d, i) => (
                          <option value={d.code} key={i}>
                            {d.label}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <select name="state" id="state" className={stateValidate} style={{ textAlign: "left" }} value={input.state.value} onChange={onHandle} disabled={disableEditInputField || enableEditTab}>
                      <option value="" selected>
                        -- State --
                      </option>
                    </select>
                  )}
                  <p className="app-auth-input__error">{input.state.error}</p>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="grid">
                <div>Subsidiary</div>
                <div className="app-input">
                  <input
                    type="checkbox"
                    className="check-box"
                    id="subsidiary-button"
                    name="subsidiary"
                    checked={input.subsidiary.value}
                    onChange={() => onHandleCheckbox("subsidiary")}
                    readOnly={disableEditInputField || enableEditTab}
                    disabled={disableEditInputField || enableEditTab}
                  />
                  <p className="app-auth-input__error"></p>
                </div>
              </div>
              {input.subsidiary.value &&
                <div className="grid">
                <div>Headquarters Email</div>
                <div className="app-input">
                  <input 
                    type="text" 
                    name="hqEmail" 
                    id="hqEmail" 
                    value={input.hqEmail.value} 
                    onChange={onHandle} 
                    className={hqEmailValidate} 
                    style={{ textAlign: "left" }} 
                    readOnly={disableEditInputField || enableEditTab} 
                  />
                  <p className="app-auth-input__error">{input.hqEmail.error}</p>
                </div>
              </div>}
              <div className="grid">
                <div>Business Reg. No</div>
                <div className="app-input">
                  <input type="text" className={businessRegNoValidate} name="businessRegNo" value={input.businessRegNo.value} onChange={onHandle} maxLength={24} readOnly={disableEditInputField || enableEditTab} />
                  <p className="app-auth-input__error">{input.businessRegNo.error}</p>
                </div>
              </div>
              <div className="grid">
                <div>Bank Name</div>
                <div className="app-input">
                  {/* <input type="text" className="app-input-text" name="bankName" value={input.bankName.value} onChange={onHandle} /> */}
                  {bankList !== undefined ? (
                    <select id="bankName" className={bankCodeValidate} name="bankCode" style={{ textAlign: "left" }} value={input.bankCode.value} onChange={onHandle} disabled={disableEditInputField || enableEditTab}>
                      <option value="" selected>
                        -- Bank Name --
                      </option>
                      {bankList
                        .sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))
                        .map((d, i) => (
                          <option value={d.code} key={i}>
                            {d.label}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <select id="bankName" className={bankCodeValidate} name="bankCode" style={{ textAlign: "left" }} value={input.bankCode.value} onChange={onHandle} disabled={disableEditInputField || enableEditTab}>
                      <option value="" selected>
                        -- Bank Name --
                      </option>
                    </select>
                  )}
                  <p className="app-auth-input__error">{input.bankCode.error}</p>
                </div>
              </div>
              <div className="grid">
                <div>Account Name</div>
                <div className="app-input">
                  <input type="text" className={accNameValidate} name="accName" value={input.accName.value} onChange={onHandle} maxLength={50} readOnly={disableEditInputField || enableEditTab} />
                  <p className="app-auth-input__error">{input.accName.error}</p>
                </div>
              </div>
              <div className="grid">
                <div>Account No</div>
                <div className="app-input">
                  <input type="text" className={accNumberValidate} name="accNumber" value={input.accNumber.value} onChange={onHandle} maxLength={19} readOnly={disableEditInputField || enableEditTab} />
                  <p className="app-auth-input__error">{input.accNumber.error}</p>
                </div>
              </div>
              {accessMerchantDetails.download_agreement && 
              <div className="grid">
                <div>Merchant Agreement</div>
                <div className="app-input" style={{ backgroundColor: "#FFFFFF" }}>
                  <img src={IconDownload} alt="Download Icon" style={{ width: "50px", paddingTop: "10px" }} onClick={openFile} />
                </div>
                <p></p>
              </div>
              }
              <div className="grid">
                <div>Effective Date</div>
                <div className="app-input">
                  <input type="text" className="app-input-text" name="effectiveDate" value={input.effectiveDate.value} />
                  {/* <IoCalendarOutline
                    size={39}
                    style={{ display: "inline-block" }}
                    onClick={() => {
                      setCalendarPopUp(true);
                    }}
                  /> */}
                  <PopUpCalendar trigger={calendarPopUp}>
                    <Calendar className="react-calendar" onChange={changeDate} minDate={new Date(modifyDate)}></Calendar>
                  </PopUpCalendar>
                  {/* <input type="date" name="effectiveDate" id="effectiveDate" className="app-input-text" value={input.effectiveDate.value} style={{ width: "200px" }} /> */}
                  <p className="app-auth-input__error">{input.effectiveDate.error}</p>
                </div>
              </div>
              <div className="grid">
                <div>End Date</div>
                <div className="app-input">
                  {/* <button className="terminate-btn" onClick={terminate}>Terminate</button> */}
                  {input.endDate.value !== null ? (
                    // <span style={{ fontSize: "18px", fontFamily: "gotham-book" }}>{input.endDate.value}</span>
                    <input type="text" className="app-input-text" value={input.endDate.value} readOnly />
                  ) : (
                    <>
                      <button
                        type="button"
                        className="terminate-btn"
                        onClick={() => {
                          setTerminatePopUp(true);
                        }}
                        disabled={!accessMerchantDetails.terminate_merchant || disableEditInputField || enableEditTab}
                        style={!accessMerchantDetails.terminate_merchant || disableEditInputField || enableEditTab ? { backgroundColor: 'grey' } : {}}
                      >
                        Terminate
                      </button>
                      <Popup trigger={terminatePopUp}>
                        <div className="pop-up-message">Are you sure you want to terminate this merchant?</div>
                      </Popup>
                    </>
                  )}
                  <p></p>
                </div>
              </div>
              <div className="grid">
                <div>Status</div>
                <div className="app-input" style={{ fontSize: "16px", fontFamily: "gotham-book" }}>
                  {/* <input type="text" className="app-input-text" name="status" value={input.status.value} /> */}
                  <input type="radio" className="radio-check" style={{ marginTop: "10px" }} onChange={handleOnChange} checked={isChecked} disabled={disableEditInputField || enableEditTab || input.status.value == 'PENDING'}  />{" "}
                  <label htmlFor="active" style={{ marginTop: "10px" }}>
                    {" "}
                    Active{"     "}
                  </label>
                  <input type="radio" className="radio-check" style={{ marginTop: "10px" }} onChange={handleOnChange} checked={!isChecked} disabled={disableEditInputField || enableEditTab || input.status.value == 'PENDING'} />{" "}
                  <label htmlFor="disabled" style={{ marginTop: "10px" }}>
                    {" "}
                    Disabled
                  </label>
                  <PopupStatus trigger={statusPopUp}>
                    <div className="pop-up-message">{isChecked === true ? "Are you sure you want to disable this merchant?" : "Are you sure you want to reactivate this merchant?"}</div>
                  </PopupStatus>
                </div>
              </div>
              {input.userStatus.value == "LOCKED" &&
                <div className="grid" style={{paddingTop: 20}}>
                  <div>Unlock</div>
                  <div className="app-input">
                    <input
                      type="checkbox"
                      className="check-box"
                      id="unlock-user-button"
                      name="unlockUserCheckbox"
                      checked={input.unlockUserCheckbox.value}
                      onChange={() => onHandleCheckbox("unlockUserCheckbox")}
                      readOnly={disableEditInputField || enableEditTab}
                    />
                    {/* <p className="app-auth-input__error"></p> */}
                  </div>
                </div>
              }
            </div>
            <div className="card">
              <div className="grid-full">
                <img src={input.qrImageUrl.value} alt="QR Code" style={{ width: "300px" }} />
              </div>
              <div className="grid-full" style={{ marginTop: "20px" }}>
                <button className="save-pdf" onClick={openPDF}>
                  Save as PDF
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className={secondTab}>
          <div style={{ display: "inline", height: "37%", marginLeft: "40px" }}>
            <span style={{ fontFamily: "gotham-bold", fontSize: "22px" }}>Merchant ID: {input.referenceNumber.value}</span>
          </div>
          <div style={{ display: "inline", float: "right", marginRight: "40px" }}>
            <select className="input-field" value={selected} onChange={onHandleOnChange}>
              <option value="- Select Range -"> - Select Range -</option>
              <option value="LAST_7_DAYS">Last 7 days</option>
              <option value="LAST_14_DAYS">Last 14 days</option>
              <option value="LAST_1_MONTH">Last month</option>
            </select>
            <span style={{ fontFamily: "gotham-bold", fontSize: "18px" }}> Custom </span>
            <input
              type={dateType[0].type}
              onFocus={onFocusDateStart}
              id="start"
              placeholder={dateType[0].placeholder}
              className="input-field"
              style={{ marginRight: "10px" }}
              onChange={onChangeDateStart}
              value={dateType[0].value}
              max={maxDate}
            />
            <input
              type={dateType[1].type}
              onFocus={onFocusDateEnd}
              id="end"
              placeholder={dateType[1].placeholder}
              className="input-field"
              onChange={onChangeDateEnd}
              value={dateType[1].value}
              min={mindate}
            />
          </div>
          <div className="page-loan-application-list__react-table-wrapper" style={{ marginTop: "10px" }}>
            {accessMerchantTrx.view_transaction_list 
              && appList !== undefined 
              && appList.data !== undefined 
              ? 
              <AppReactTable 
                columns={tableColumn} 
                data={appList.data} 
                headerClass="userContractDetailsHeader"
              headerRowClass="userContractDetailsHeader__row"
              rowHeaderClass="userContractDetailsHeader__row-header"
              bodyClass="userContractDetailsBody"
              bodyRowClass="userContractDetailsBody__row"
                bodyDataClass="userContractDetailsBody__row-data"
              /> 
              : <div></div>
            }
          </div>
          <div className="pagination-button" style={{ float: "right" }}>
            {appList !== undefined ? (
              <span>
                {tableSearchFilter.pageNo === 1 && appList.totalCount > 0
                  ? tableSearchFilter.pageNo
                  : tableSearchFilter.pageNo === 1 && appList.totalCount === 0
                    ? appList.totalCount
                    : 1 + appList.pageSize * (appList.currentPageNumber - 1)}{" "}
                - {""}
                {appList.pageSize * (appList.currentPageNumber - 1) + appList.currentCount} of {appList.totalCount}{" "}
              </span>
            ) : (
              <></>
            )}
            <button onClick={() => previousPage()}>❮</button>
            <button onClick={() => nextPage()}>❯</button>
          </div>
        </div>
        <div className={thirdTab}>
          <div className="page-loan-application-list__react-table-wrapper" style={{ marginTop: "10px" }}>
            {accessMerchantTerminal.view_merchant_terminal_list 
              && terminalList !== undefined 
              && terminalList.data !== undefined 
              ? 
              <AppReactTable 
                columns={terminalTableColumn} 
                data={terminalList.data} 
                headerClass="userContractDetailsHeader"
              headerRowClass="userContractDetailsHeader__row"
              rowHeaderClass="userContractDetailsHeader__row-header"
              bodyClass="userContractDetailsBody"
              bodyRowClass="userContractDetailsBody__row"
                bodyDataClass="userContractDetailsBody__row-data" 
              /> 
              : <div></div>
            }
          </div>
          <div className="pagination-button" style={{ float: "right" }}>
            {terminalList !== undefined ? (
              <span>
                {tableSearchFilter.pageNo === 1 && terminalList.totalCount > 0
                  ? tableSearchFilter.pageNo
                  : tableSearchFilter.pageNo === 1 && terminalList.totalCount === 0
                    ? terminalList.totalCount
                    : 1 + terminalList.pageSize * (terminalList.currentPageNumber - 1)}{" "}
                - {""}
                {terminalList.pageSize * (terminalList.currentPageNumber - 1) + terminalList.currentCount} of {terminalList.totalCount}{" "}
              </span>
            ) : (
              <></>
            )}
            <button onClick={() => previousTerminalPage()}>❮</button>
            <button onClick={() => nextTerminalPage()}>❯</button>
          </div>
        </div>
{/********Testing Tab************/}
        <div className={forthTab}>
          <div className="cards" style={{ paddingTop: "30px" }}>
            <div className="card">
              {/* <div className="grid-container">
                                <div className="item1">Merchant ID</div>
                                <div className="res-data"><span>{input.referenceNumber.value} asd ads asdf a fadfdfa</span></div>
                            </div>
                            <div className="grid-container">
                                <div className="item1">Merchant Name</div>
                                <div className="res-data"><span>{input.name.value}</span></div>
                            </div> */}
              <div className="grid">
                <div>Merchant ID</div>
                {/* <div className="res-data">
                                    <span>{input.referenceNumber.value}</span>
                                </div> */}
                <div className="app-input">
                  <input type="text" className="app-input-text" name="referenceNumber" value={input.referenceNumber.value} readOnly />
                  <p></p>
                </div>
              </div>
              <div className="grid">
                <div className={nameLbl}>Merchant Name</div>
                {/* <div className="res-data">
                                    <span>{input.name.value}</span>
                                </div> */}
                <div className="app-input">
                  <input type="text" className={nameValidate} name="name" value={inputUp.name.value} onChange={onUpdate} maxLength={50}  readOnly={enableEditInputField}/>
                  <p className="app-auth-input__error">{input.name.error}</p>
                </div>
              </div>
              <div className="grid">
                <div className={emailLbl}>Merchant Email</div>
                <div className="app-input">
                  <input type="text" className={emailValidate} name="email" value={inputUp.email.value} onChange={onUpdate}  readOnly={enableEditInputField}/>
                  <p className="app-auth-input__error">{input.email.error}</p>
                </div>
              </div>
              <div className="grid">
                <div className={mobilePhoneLbl}>Mobile Phone</div>
                <div className="app-input">
                  <input type="text" className={mobilePhoneValidate} name="mobile" value={inputUp.mobile.value} onChange={onUpdate} maxLength={11}  readOnly={enableEditInputField}/>
                  <p className="app-auth-input__error">{input.mobile.error}</p>
                </div>
              </div>
              <div className="grid">
               <div className={categoryLbl}>Category Name</div>
                <div className="app-input">
                   <input type="text" className={categoryValidate} name="category" value={inputUp.category.value} onChange={onUpdate} readOnly={disableEditInputField || enableEditTab} />
                    <p className="app-auth-input__error"></p>
                   </div>
              </div>
              <div className="grid">
                <div className={address1Lbl}>Address 1</div>
                <div className="app-input">
                  {/* <input type="text" className="app-input-text" name="address1" value={input.address1.value} onChange={onHandle} /> */}
                  <textarea name="address1" id="address1" className={address1Validate} value={inputUp.address1.value} onChange={onUpdate} maxLength={100} readOnly={enableEditInputField}></textarea>
                </div>
                <div className="app-input">
                  <p className="app-auth-input__error"></p>
                </div>
                <div className="app-input">
                  <p className="app-auth-input__error">{input.address1.error}</p>
                </div>
              </div>
              <div className="grid">
                <div className={address2Lbl}>Address 2</div>
                <div className="app-input">
                  {/* <input type="text" className="app-input-text" name="address2" value={input.address2.value} onChange={onHandle} /> */}
                  <textarea name="address2" id="address2" className={address2Validate} value={inputUp.address2.value} onChange={onUpdate} maxLength={100} readOnly={enableEditInputField}></textarea>
                </div>
                <div className="app-input">
                  <p></p>
                </div>
              </div>
              <div className="grid">
                <div className={cityLbl}>City / Town</div>
                <div className="app-input">
                  <input type="text" className={cityValidate} name="city" value={inputUp.city.value} onChange={onUpdate} maxLength={50} readOnly={enableEditInputField} />
                  <p className="app-auth-input__error">{input.city.error}</p>
                </div>
              </div>
              <div className="grid">
                <div className={postcodeLbl}>Postcode</div>
                <div className="app-input">
                  <input type="text" className={postcodeValidate} name="postcode" value={inputUp.postcode.value} onChange={onUpdate} maxLength={5} readOnly={enableEditInputField} />
                  <p className="app-auth-input__error">{input.postcode.error}</p>
                </div>
              </div>
              <div className="grid">
                <div className={stateLbl}>State</div>
                <div className="app-input">
                  {/* <input type="text" className="app-input-text" name="state" value={input.state.value} onChange={onHandle} /> */}
                  {stateList !== undefined ? (
                    <select name="state" id="state" className={stateValidate} style={{ textAlign: "left" }} value={inputUp.state.value} onChange={onUpdate} disabled={enableEditInputField}>
                      <option value="" selected>
                        -- State --
                      </option>
                      {stateList
                        .sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))
                        .map((d, i) => (
                          <option value={d.code} key={i}>
                            {d.label}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <select name="state" id="state" className={stateValidate} style={{ textAlign: "left" }} value={inputUp.state.value} onChange={onUpdate} disabled={enableEditInputField}>
                      <option value="" className={stateLbl} selected>
                        -- State --
                      </option>
                    </select>
                  )}
                  <p className="app-auth-input__error">{input.state.error}</p>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="grid">
                <div className={subsidiaryLbl}>Subsidiary</div>
                <div className="app-input">
                  <input
                    type="checkbox"
                    className="check-box"
                    id="subsidiary-button"
                    name="subsidiary"
                    checked={inputUp.subsidiary.value}
                    onChange={() => onHandleCheckbox("subsidiary")}
                    readOnly={!accessMerchantDetails.update_merchant || enableEditInputField}
                  />
                  <p className="app-auth-input__error"></p>
                </div>
              </div>
              {inputUp.subsidiary.value &&
                <div className="grid">
                <div className={hqEmailLbl}>Headquarters Email</div>
                <div className="app-input">
                  <input 
                    type="text" 
                    name="hqEmail" 
                    id="hqEmail" 
                    value={inputUp.hqEmail.value} 
                    onChange={onHandle} 
                    className={hqEmailValidate} 
                    style={{ textAlign: "left" }} 
                    readOnly={disableEditInputField} 
                  />
                  <p className="app-auth-input__error">{inputUp.hqEmail.error}</p>
                </div>
              </div>}
              <div className="grid">
                <div className={businessRegNoLbl}>Business Reg. No</div>
                <div className="app-input">
                  <input type="text" className={businessRegNoValidate} name="businessRegNo" value={inputUp.businessRegNo.value} onChange={onUpdate} maxLength={24} readOnly={enableEditInputField} />
                  <p className="app-auth-input__error">{input.businessRegNo.error}</p>
                </div>
              </div>
              <div className="grid">
                <div className={bankCodeLbl}>Bank Name</div>
                <div className="app-input">
                  {/* <input type="text" className="app-input-text" name="bankName" value={input.bankName.value} onChange={onHandle} /> */}
                  {bankList !== undefined ? (
                    <select id="bankName" className={bankCodeValidate} name="bankCode" style={{ textAlign: "left" }} value={inputUp.bankCode.value} onChange={onUpdate} disabled={enableEditInputField}>
                      <option value="" selected>
                        -- Bank Name --
                      </option>
                      {bankList
                        .sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))
                        .map((d, i) => (
                          <option value={d.code} key={i}>
                            {d.label}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <select id="bankName" className={bankCodeValidate} name="bankCode" style={{ textAlign: "left" }} value={inputUp.bankCode.value} onChange={onUpdate} disabled={enableEditInputField}>
                      <option value=""  className={bankCodeLbl} selected>
                        -- Bank Name --
                      </option>
                    </select>
                  )}
                  <p className="app-auth-input__error">{input.bankCode.error}</p>
                </div>
              </div>
              <div className="grid">
                <div className={accNameLbl}>Account Name</div>
                <div className="app-input">
                  <input type="text" className={accNameValidate} name="accName" value={inputUp.accName.value} onChange={onUpdate} maxLength={50} readOnly={enableEditInputField} />
                  <p className="app-auth-input__error">{input.accName.error}</p>
                </div>
              </div>
              <div className="grid">
                <div className={accNumberLbl}>Account No</div>
                <div className="app-input">
                  <input type="text" className={accNumberValidate} name="accNumber" value={inputUp.accNumber.value} onChange={onUpdate} maxLength={19} readOnly={enableEditInputField} />
                  <p className="app-auth-input__error">{input.accNumber.error}</p>
                </div>
              </div>
              {accessMerchantDetails.download_agreement && 
              <div className="grid">
                <div>Merchant Agreement</div>
                <div className="app-input" style={{ backgroundColor: "#FFFFFF" }}>
                  <img src={IconDownload} alt="Download Icon" style={{ width: "50px", paddingTop: "10px" }} onClick={openFile} />
                </div>
                <p></p>
              </div>
              }
              <div className="grid">
                <div>Effective Date</div>
                <div className="app-input">
                  <input type="text" className="app-input-text" name="effectiveDate" value={input.effectiveDate.value} />
                  {/* <IoCalendarOutline
                    size={39}
                    style={{ display: "inline-block" }}
                    onClick={() => {
                      setCalendarPopUp(true);
                    }}
                  /> */}
                  <PopUpCalendar trigger={calendarPopUp}>
                    <Calendar className="react-calendar" onChange={changeDate} minDate={new Date(modifyDate)}></Calendar>
                  </PopUpCalendar>
                  {/* <input type="date" name="effectiveDate" id="effectiveDate" className="app-input-text" value={input.effectiveDate.value} style={{ width: "200px" }} /> */}
                  <p className="app-auth-input__error">{input.effectiveDate.error}</p>
                </div>
              </div>
              <div className="grid">
                <div className={endDateLbl}>End Date</div>
                <div className="app-input">
                  {/* <button className="terminate-btn" onClick={terminate}>Terminate</button> */}
                  {inputUp.endDate.value !== null ? (
                    // <span style={{ fontSize: "18px", fontFamily: "gotham-book" }}>{input.endDate.value}</span>
                    <input type="text" className="app-input-text" value={inputUp.endDate.value} readOnly />
                  ) : (
                    <>
                      <button
                        type="button"
                        className="terminate-btn"
                        onClick={() => {
                          setTerminatePopUp(true);
                        }}
                        disabled={!accessMerchantDetails.terminate_merchant || enableEditInputField}
                        style={!accessMerchantDetails.terminate_merchant || enableEditInputField ? { backgroundColor: 'grey' } : {}}
                      >
                        Terminate
                      </button>
                      <Popup trigger={terminatePopUp}>
                        <div className="pop-up-message">Are you sure you want to terminate this merchant?</div>
                      </Popup>
                    </>
                  )}
                  <p></p>
                </div>
              </div>
              <div className="grid">
                <div className={statusLbl}>Status</div>
                <div className="app-input" style={{ fontSize: "16px", fontFamily: "gotham-book" }}>
                  {/* <input type="text" className="app-input-text" name="status" value={input.status.value} /> */}
                  <input type="radio" name="active" id="active" className="radio-check" style={{ marginTop: "10px" }} onChange={handleOnChange} checked={isStatusChecked} disabled={enableEditInputField || input.status.value == 'PENDING'} />{" "}
                  <label htmlFor="active" style={{ marginTop: "10px" }}>
                    {" "}
                    Active{"     "}
                  </label>
                  <input type="radio" name="disabled" id="disabled" className="radio-check" style={{ marginTop: "10px" }} onChange={handleOnChange} checked={!isStatusChecked} disabled={enableEditInputField || input.status.value == 'PENDING'} />{" "}
                  <label htmlFor="disabled" style={{ marginTop: "10px" }}>
                    {" "}
                    Disabled
                  </label>
                  <PopupStatus trigger={statusPopUp}>
                    <div className="pop-up-message">{isChecked === true ? "Are you sure you want to disable this merchant?" : "Are you sure you want to reactivate this merchant?"}</div>
                  </PopupStatus>
                </div>
              </div>
              {input.userStatus.value == "LOCKED" &&
                <div className="grid" style={{paddingTop: 20}}>
                  <div>Unlock</div>
                  <div className="app-input">
                    <input
                      type="checkbox"
                      className="check-box"
                      id="unlock-user-button"
                      name="unlockUserCheckbox"
                      checked={input.unlockUserCheckbox.value}
                      onChange={() => onHandleCheckbox("unlockUserCheckbox")}
                      readOnly={!accessMerchantDetails.update_merchant}
                    />
                    {/* <p className="app-auth-input__error"></p> */}
                  </div>
                </div>
              }
            </div>
            <div className="card">
              <div className="grid-full">
                <img src={input.qrImageUrl.value} alt="QR Code" style={{ width: "300px" }} />
              </div>
              <div className="grid-full" style={{ marginTop: "20px" }}>
                <button className="save-pdf" onClick={openPDF}>
                  Save as PDF
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageMerchantView;
